<template>
  <div class="manage-members height-inherit flex" id="manage-members">
    <div id="captcha"></div>
    <div class="group">
      <div class="add-group">
        <w-button @click.stop="handlerAdd()">新建分组</w-button>
      </div>
      <div class="group-container">
        <w-scrollbar
          wrap-style="overflow-x: hidden;"
          style="width: 100%; height: 98%; overflow-x: hidden"
        >
          <div class="height-full">
            <div class="group--all">
              <div
                :style="{ background:(departmentName === '全公司'?'#F3F4F7':''),color:(departmentName === '全公司'?'#2079FA':'') }"
                class="group-name" @click="clickGroupNode({departmentId: null, departmentName: '全公司'})">
                <i style="fontSize:20px;margin-top:-5px;margin-left: 12px !important;"
                   class="r2-icon-nav_arrow_drop_down margin-left-0" :class="{expand: showAll}"
                   @click.stop="showAll = !showAll"></i>全公司
              </div>
              <collapse>
                <w-tree
                  :data="groupData"
                  v-show="showAll && groupData.length>0"
                  :props="defaultProps"
                  ref="tree"
                  :highlight-current="true"
                  :default-expand-all='isExpand'
                  node-key="departmentId"
                  :expand-on-click-node="true"
                >
                  <div class="custom-tree-node" slot-scope="{ node, data }">
                    <template v-if="data.isEditor">
                      <div class="editor" style="width:100%" @click.stop>
                        <w-input
                          :autofocus="data.isEditor"
                          :ref="!data.departmentId?'focusInput':''"
                          @blur.stop="organizationBlur(data)"
                          @keyup.enter.native="$event.target.blur"
                          v-model.trim="data.departmentName" maxlength="30" minlength="1">
                        </w-input>
                        <p class="color-red font-12 padding-top-5" style="white-space: pre-wrap;line-height: 20px;"
                           v-if="data.groupValidateError">{{data.groupValidateMessage}}</p>

                      </div>
                    </template>
                    <div class="flex item-container" @click.stop="clickGroupNode(data)" v-else>
                      <span class="organizationTitle" :title="node.label.length>8?node.label:''">{{ node.label }}</span>
                      <span @click.stop>
                      <w-dropdown @visible-change="treeDropdownHandle(data)" @command="handleCommand" class="dropDown"
                                  trigger="click">
                        <span :class="data.hover ? 'icon-block' : ''" class="w__dropdown-link icon relative">
                           <i class="r2-icon-nav_more_vert"></i>
                        </span>
                        <w-dropdown-menu slot="dropdown">
                          <w-dropdown-item :command="beforeHandleCommand(data,'edit')">编辑</w-dropdown-item>
                          <w-dropdown-item :command="beforeHandleCommand(data,'add')">添加子部门</w-dropdown-item>
                          <w-dropdown-item :command="beforeHandleCommand(data,'delete')">删除</w-dropdown-item>
                        </w-dropdown-menu>
                      </w-dropdown>
                    </span>
                    </div>
                  </div>
                </w-tree>
              </collapse>
            </div>
            <div
              :class="['group--deleted', showFrozenAccount ? 'active' : '']"
              @click.self="showFrozenAccountList">
              已冻结账号
              <!-- 已冻结账号提示 -->
              <div class="frozen-tips" v-if="showFrozenTip">
              <span class="triangle"></span>
              <span class="rectangle">
              <div class="r2-icon-Click rectangle-i"></div>
              <div class="rectangle-span">为优化企业账号使用，已将长时间未登录使用的无授权账号设置为冻结账号</div>
              <i
                class="r2-icon-nav_close prj-tips-i"
              @click.stop="closeFrozenTip"
              ></i>
              </span>
                  </div>
            </div>
            <div
              :class="['group--deleted', showDeletedStaff ? 'active' : '']"
              @click="showDeletedStaffList">
              已删除账号
            </div>
            <!--<div-->
              <!--:class="['group&#45;&#45;deleted', showOrganization ? 'active' : '']"-->
              <!--@click="showOrganizationList">-->
              <!--跨组织关系-->
            <!--</div>-->
          </div>
        </w-scrollbar>
      </div>
    </div>
    <div class="flex-1 relative">
      <div class="absolute box" id="table-container">
        <div class="table-container" v-if="(!showDeletedStaff && !showOrganization && !showFrozenAccount)">
          <div class="btn-wrapper flex" id="table-header-wrapper">
            <div class="group-name ellipsis">{{ departmentName }}</div>
            <div class="button-group flex-1 text-align-right">
              <w-button type="primary" @click="addMember" style="vertical-align: top">
                <i class="r2-icon-content_add"></i><span>添加员工</span>
              </w-button>
              <w-button ghost @click="batchAddMember">批量添加</w-button>
              <!--<w-button ghost @click="fastAddMember()">一键创建员工</w-button>-->
              <w-button ghost @click="inviteMembers()" :style="{ marginRight:(!(isIndeterminate || checkAll) ? '10px':'')}">邀请</w-button>
              <w-button ghost @click="moveMembers" v-show="(isIndeterminate || checkAll)">移动到</w-button>
              <w-button ghost type="warning" @click="onBatchDelete" v-show="(isIndeterminate || checkAll)" style="margin-right: 10px">删除</w-button>
              <w-form class="inline-block" @submit.native.prevent>

                <!-- --2020.9.9资产管理批量查询产品许可接口性能影响-紧急需求输入 越平邮件输入 -->
                <!-- <w-select class="search_type_select" size="small" style="width: 110px" @change="changeSearchType" v-model="selectType" placeholder="请选择">
                  <w-option label="姓名" value="userName"></w-option>
                  <w-option label="产品名称" value="productName"></w-option>
                </w-select>
                <w-input
                  class="search_type_input"
                  style="width: 220px"
                  clearable
                  size="small"
                  :placeholder="selectType === 'userName' ? '请输入姓名/账号' : '请输入产品名称'"
                  v-model="keyword"
                  @keyup.enter.native="handlerSearch"
                >
                  <i
                    slot="prefix"
                    class="w__input__icon r2-icon-action_search"
                    style="font-size: 16px !important"
                  ></i>
                  <i
                    v-if="keyword !== ''"
                    class="r2-icon-nav_cancel cursor-pointer"
                    style="lineHeight: 32px;"
                    slot="suffix"
                    @click="keyword = '';handlerSearch()">
                  </i>
                </w-input> -->
                 <!-- --2020.9.9资产管理批量查询产品许可接口性能影响-紧急需求输入 越平邮件输入 -->
                 <w-input
                  style="width: 220px"
                  clearable
                  size="small"
                  :placeholder="selectType === 'userName' ? '请输入姓名/账号' : '请输入产品名称'"
                  v-model="fuuzzySearch"
                  @keyup.enter.native="handlerSearch"
                >
                  <i
                    slot="prefix"
                    class="w__input__icon r2-icon-action_search"
                    style="font-size: 16px !important"
                  ></i>
                  <i
                    v-if="fuuzzySearch !== ''"
                    class="r2-icon-nav_cancel cursor-pointer"
                    style="lineHeight: 32px;"
                    slot="suffix"
                    @click="fuuzzySearch = '';handlerSearch()">
                  </i>
                </w-input>
              </w-form>
            </div>
          </div>
          <div class="table-wrapper block" id="scrollBody">
            <div
              class="ui-fixed tree-table fit flex flex-column table-medium table-beyond-hiding"
              :style="{ height: tableHeight + 'px' }"
              id="tree-table"
              v-loading="loading"
            >
              <div class="header-wrapper" ref="headerWrapper">
                <div
                  class="table-header flex flex-row"
                  :style="{
                    width: (scrollY ? tableWidth + 5 : tableWidth) + 'px'
                  }"
                >
                  <div class="header-item is-leaf is-center" style="width: 28px;padding-left: 0;">
                    <w-checkbox :indeterminate="isIndeterminate" :disabled="(data.length === 0) ? true : false"
                            v-model="checkAll"
                            @change="handleCheckAllChange"></w-checkbox>
                  </div>
                  <div class="header-item is-leaf" style="width: 120px">
                    员工姓名
                  </div>
                  <div class="header-item is-leaf" style="width: 120px">
                    <span class="header-explain-relative">
                      岗位
                      <el-tooltip class="item" effect="dark" placement="bottom-start" :offset="-7">
                        <template slot="content">
                          <div style="font-size: 14px;line-height:22px; padding-bottom: 6px;">
                            <span style="lineheight: 30px">
                            总负责人拥有企业最高管理权限；
                          </span>
                          <br/>
                          <span style="line-height: 30px">
                            未分配管理权限的普通员工有普通使用权；
                          </span>
                          <br/>
                          分配了数据库（企业材料库、企业指标库、计价依<br/>据库、组价数据库、量价规则库、共享资料库）管<br/>理权限的普通员工拥有对应数据库的管理权。
                          </div>
                        </template>
                        <i class="w-icon-wenhao header-explain"></i>
                      </el-tooltip>
                    </span>
                  </div>
                  <div class="header-item is-leaf" style="width: 140px">
                    密保手机
                  </div>
                  <!-- <div class="header-item is-leaf" style="width: calc(100% - 540px)">
                    管理权限
                  </div> -->
                  <!-- <div class="header-item is-leaf" style="text-align: center; width: 150px;">
                    <span class="text-center header-explain-relative text-align-center">
                      企业数据看板
                      <el-tooltip class="item" effect="dark" placement="bottom-start" :offset="-7">
                        <template slot="content">
                          <div style="fontSize: 14px;lineHeight:22px;">
                            勾选后，员工可看到工作台页<br/>面下的企业数据看板内容；取<br/>消勾选后，员工无法看到企业<br/>数据看板内容
                          </div>
                        </template>
                        <i class="w-icon-wenhao header-explain"></i>
                      </el-tooltip>
                    </span>
                  </div> -->
                  <!-- <div class="header-item is-leaf" style="width: 150px">云锁</div> -->
                  <div class="header-item is-leaf" style="width: 150px">
                    操作
                  </div>
                  <div class="has-gutter" v-if="scrollY"></div>
                </div>
              </div>
              <div
                class="body-wrapper flex-1"
                style="overflow: auto; position: relative"
                ref="bodyWrapper"
              >
                <ul
                  class="container"
                  style="position: relative; minwidth: 1125px"
                  ref="containerWrapper"
                >
                  <li
                    class="flex flex-row row row--level-1 hover-row"
                    :style="{ width: tableWidth + 'px' }"
                    v-for="(item, index) in data"
                    :key="index"
                  >
                    <div class="cell column_1 is-center" style="width:28px;padding-left:0;" :style="{backgroundColor:item.hover?'#F3F4F7':'white'}">
                        <w-checkbox v-model="item.checkbox" @change="handleCheckedCitiesChange(item)"
                                    ></w-checkbox>
                      </div>
                    <div class="cell column_1" :style="{backgroundColor:item.hover?'#F3F4F7':'white'}"
                         style="width: 120px">
                      <w-popover
                        placement="right"
                        min-width="255"
                        trigger="hover"
                        :offset="-5"
                      >
                        <div
                          style="
                            lineHeight: 30px;
                            fontSize: 14px;
                            padding: 4px;
                          "
                        >
                          <div>员工账号：{{ item.account }}</div>
                          <div>密保手机：{{ item.passwordMobile === "null" ? ' ' : item.passwordMobile }}</div>
                          <div>
                            所属分组：{{ item.departmentNameVal}}
                          </div>
                          <div>空间使用：{{ item.size }}</div>
                        </div>
                        <span slot="reference" class="hover-link">{{
                          item.name
                        }}</span>
                      </w-popover>
                    </div>
                    <!-- 角色设置 -->
                    <div class="cell column_2" :style="{backgroundColor:item.hover?'#F3F4F7':'white'}"
                         style="width: 120px">
                      <div style="margin-right: 8px">
                        {{ roleMap[item.role] }}
                      </div>
                      <div class="float_right">
                        <w-dropdown
                          size="medium"
                          @command="updateRole"
                          @click.native="sentLog(100117050)"
                        >
                          <span class="w__dropdown-link">
                            <w-button
                              type="minor"
                              style="padding: 2px 1px; height: 20px"
                            >
                              <i
                                class="r2-icon-nav_arrow_drop_down margin-left-0"
                                style="
                                  font-size: 16px !important;
                                  lineheight: 15px;
                                "
                              ></i>
                            </w-button>
                          </span>
                          <w-dropdown-menu slot="dropdown">
                            <w-dropdown-item
                              v-for="(role, index) in roleList"
                              :key="role.roleId"
                              :command="{ item, roleId: role.roleId }"
                              :style="{
                                color:
                                  item.role === role.roleId ? '#2079FA' : '',
                                width: '90px'
                              }"
                            >{{ role.name }}
                            </w-dropdown-item
                            >
                          </w-dropdown-menu>
                        </w-dropdown>
                      </div>
                    </div>
                    <!-- 密保手机 -->
                    <div class="cell column_11" :style="{backgroundColor:item.hover?'#F3F4F7':'white'}"
                         style="width: 140px">
                      <div>
                        {{ item.passwordMobile==='null'? ' ' : item.passwordMobile}}
                      </div>
                     </div>
                    <!-- 管理权限 -->
                    <!-- <div class="cell column_3" :style="{backgroundColor:item.hover?'#F3F4F7':'white'}"
                         style="width: calc(100% - 540px)">
                      <div
                        v-if="item.role == 2"
                        class="flex justify-center align-center"
                        style="width: 100%">
                        <span class="flex-1"> 全部 </span>
                        <w-dropdown
                          trigger="click"
                          :hide-on-click="false"
                          @visible-change="dropdownHandle(item)">
                          <span
                            :id="'user_' + item.gldUserId"
                            class="w__dropdown-link hover-show"
                            :class="item.hover ? 'hoverBlock' : ''"
                            style="width: 30px; float: right">
                           <i class="r2-icon-action_settings w__icon--right hover-link"></i>
                          </span>
                          <w-dropdown-menu style="padding:8px 0;" class="tableDropMenu" slot="dropdown">
                            <w-dropdown-item
                              style="padding: 0 16px 0 8px;line-height: 32px;"
                              icon="w__icon-plus"
                              v-for="(child,index) of item.enterpriseDBManagerList"
                              :key="index">
                              <w-checkbox
                                :checked="true"
                                v-model="istrue"
                                disabled>{{ child.description }}
                              </w-checkbox>
                            </w-dropdown-item>
                          </w-dropdown-menu>
                        </w-dropdown>
                      </div>
                      <div v-else-if="item.manage && item.manage.length == 0">无</div>
                      <div
                        v-else
                        class="flex justify-center align-center"
                        style="width: 100%">
                        <span class="flex-1">{{ item.enterpriseDBManagerList | permissionFilter }}</span>
                        <w-dropdown
                          trigger="click"
                          :hide-on-click="false"
                          @visible-change="dropdownHandle(item)">
                          <span
                            :id="'user_' + item.gldUserId"
                            class="w__dropdown-link hover-show"
                            :class="item.hover ? 'hoverBlock' : ''"
                            style="width: 30px; float: right">
                            <i class="r2-icon-action_settings w__icon--right hover-link"></i>
                          </span>
                          <w-dropdown-menu style="padding:8px 0;" slot="dropdown">
                            <w-dropdown-item
                              icon="w__icon-plus"
                              style="padding: 0 16px 0 8px;line-height: 32px;"
                              v-for="(child,index) of item.enterpriseDBManagerList"
                              :key="index">
                              <w-checkbox
                                v-model="child.check"
                                @change="updateManageHandle(child, item)">{{ child.description }}
                              </w-checkbox>
                            </w-dropdown-item>
                          </w-dropdown-menu>
                        </w-dropdown>
                      </div>
                    </div> -->
                    <!-- 企业数据看板 -->
                    <!-- <div class="cell column_4 text-align-center" :style="{backgroundColor:item.hover?'#F3F4F7':'white'}"
                         style="width: 150px;">
                      <w-checkbox v-if="item.role===2" disabled v-model="item.canReadEnterpriseWorkbench"
                                  :checked="item.canReadEnterpriseWorkbench"
                                  style="text-align: center; width: 100%;"></w-checkbox>
                      <w-checkbox v-else :checked="item.canReadEnterpriseWorkbench"
                                  v-model="item.canReadEnterpriseWorkbench" @change="dashboardAuthority(item)"
                                  style="text-align: center; width: 100%;"></w-checkbox>
                    </div> -->
                     <!-- --2020.9.9资产管理批量查询产品许可接口性能影响-紧急需求输入 越平邮件输入 -->
                    <!-- <div class="cell column_5" :style="{backgroundColor:item.hover?'#F3F4F7':'white'}" style="width: 150px">
                      <div class="padding-10-0">
                        <div v-for="(asset, index) in item.assetToDetail" :class="{'margin-bottom-10': index !== item.assetToDetail.length - 1}">
                          <el-tooltip
                            class="item"
                            effect="dark"
                            placement="bottom"
                            :offset="-7">
                            <div
                              slot="content"
                              style="font-size: 14px;line-height: 22px;padding-bottom: 6px;width: 350px;max-height: 210px;overflow: auto;">
                              <w-scrollbar wrap-style="overflow-x: hidden;" style="width: 100%; height: 98%; overflow-x: hidden">
                                <div>
                                  <span style="line-height: 26px;">{{ asset.assetNum }}</span>
                                  <br/>
                                  <div v-for="(product, index) of asset.products" style="line-height: 22px;" :key="index">
                                    {{ product }}
                                  </div>
                                  <div style="height: 8px"></div>
                                </div>
                              </w-scrollbar>
                            </div>
                            <span class="cursor-default" :class="{'text-no': asset.status != 'online' && asset.status != 'borrow' && asset.status != 'notUsed'}">
                            {{
                              asset.status === "online" ? "联网使用"
                                : asset.status === "borrow" ? "借出使用"
                                  : asset.status === 'notUsed' ? "未使用" : ""
                            }}
                          </span>
                          </el-tooltip>
                        </div>
                      </div>
                    </div> -->
                    <!-- <div class="cell column_5" style="width: 150px;">
                      <el-tooltip v-if="Array.isArray(item.assetNums) && item.assetNums.length" placement="right">
                        <span class="asset-item--default">
                          {{ item.assetNums.length > 1 ? item.assetNums[0] + ' 等' : item.assetNums[0] }}
                        </span>
                        <ul slot="content">
                          <li class="asset-item asset-item--title">资产编号:</li>
                          <li class="asset-item" v-for="(asset, idx) in item.assetNums" :key="'asset-' + idx">
                            {{asset}}
                          </li>
                        </ul>
                      </el-tooltip>
                    </div>
                    <div class="cell column_6" style="width: 150px;">
                      <el-tooltip width="200px">
                        <template slot="content">
                          <div style="line-height: 18px;max-width: 300px;max-height: 200px;overflow: auto;white-space:nowrap;">
                            <p v-for="packageName in (item.assetDetail ? item.assetDetail : [])">{{packageName}}</p>
                          </div>
                        </template>
                        <div class="ellipsis" style="max-width: 130px;">{{item.assetDetail ? item.assetDetail.toString() : ''}}</div>
                      </el-tooltip>
                    </div>-->
                    <div class="cell column_10" :style="{backgroundColor:item.hover?'#F3F4F7':'white'}" style="width: 150px;">
                      <div style="width: 100%">
                        <span class="opration-text cursor-pointer" @click="handlerAction({ item, type: 'config' })" >资产分配</span>
                        <w-dropdown @command="handlerAction">
                          <span class="w__dropdown-link">
                            <span class="more opration-text cursor-pointer"
                            >更多
                            </span>
                          </span>
                          <w-dropdown-menu slot="dropdown">
                            <w-dropdown-item :command="{ item, type: 'editor' }"
                            >编辑
                            </w-dropdown-item
                            >
                            <w-dropdown-item
                              :command="{ item, type: 'password' }"
                            >重置密码
                            </w-dropdown-item
                            >
                            <w-dropdown-item
                              :command="{ item, type: 'setting' }"
                              :disabled="
                                !(item.assetNums && item.assetNums.length)
                              "
                            >
                              设置借出
                            </w-dropdown-item>
                            <w-dropdown-item
                              :command="{ item, type: 'delete' }"
                              divided
                            >删除
                            </w-dropdown-item
                            >
                          </w-dropdown-menu>
                        </w-dropdown>
                      </div>
                    </div>
                  </li>
                  <!-- 操作提示 -->
                  <li class="members-tips" v-if="data.length && showMemTips">
                    <span class="triangle"></span>
                    <span class="rectangle">
                      <i class="r2-icon-Click"></i>
                      <span>密码重置在这里</span>
                      <i
                        class="r2-icon-nav_close prj-tips-i"
                        @click.stop="closeTips"
                      ></i>
                    </span>
                  </li>
                  <!-- 缺少总负责人提示 -->
                  <li class="role-tips" v-if="data.length && showRoleTip">
                    <span class="triangle"></span>
                    <div class="rectangle">
                      <span class="content-tips"
                      >为了员工能够正常使用各产品，请至少指定一个员工为总负责人</span
                      >
                      <i class="r2-icon-Click"></i>
                      <i
                        class="r2-icon-nav_close prj-tips-i"
                        @click.stop="closeRoleTip"
                      ></i>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="text-align-right padding-top-5" v-if="data.length">
              <w-pagination
                @current-change="handleCurrentChange"
                @size-change="handlePageSizeChange"
                :current-page.sync="pagination.pageNum"
                background
                layout="total, prev, pager, next, jumper,sizes"
                :page-size="pagination.pageSize"
                :page-sizes="[50, 100]"
                :total="pagination.total"
              ></w-pagination>
            </div>
            <w-dialog @close="handleCloseSuffix" :show="showSetSuffix" title="设置企业员工账号后缀" :wallStyle="{zIndex: 2001}" :box-style="{width: '500px',zIndex: 2001}" :bodyStyle="{padding: '0px 15px 0 15px'}">
              <div class="padding-20-0">
                <div class="suffix-reg-tip">
                  <p>1、该账号后缀为<span>企业所有员工账号的统一后缀标识，不是您的个人信息，</span>请您谨慎填写；</p>
                  <p>2、员工账号后缀由3-15个字母或数字组成，<span>设置后不可修改；</span></p>
                </div>
                <w-form ref="suffixForm" :model="suffixForm" label-width="110px" size="mini" :rules="suffixRules">
                  <w-form-item label="员工账号@" prop="suffix">
                    <w-input size="small" v-model.trim="suffixForm.suffix" placeholder="示例：建议使用企业首字母缩写，如广联达为GLD" @change="suffixValidateMessage = ''"></w-input>
                    <p class="color-red padding-top-5" v-if="suffixValidateMessage">{{suffixValidateMessage}}</p>
                  </w-form-item>
                </w-form>
              </div>
              <div slot="footer">
                <w-button type="primary" size="small" @click="handlerSetSuffix">确定</w-button>
                <w-button size="small" @click="handleCloseSuffix">取消</w-button>
              </div>
            </w-dialog>
            <!-- 添加/编辑员工账号 弹窗 -->
            <w-dialog
              @close="handlerClose"
              :show="showAddMember"
              :title="`${isEditor ? '编辑' : '添加'}员工账号`"
              :wallStyle="{ zIndex: 2001 }"
              :box-style="{ width: '500px', zIndex: 2001 }"
              :bodyStyle="{ padding: '24px 24px 0 24px' }"
              :footerStyle="{
                padding: '2px 24px 24px 24px',
                borderTop: 'none'
              }"
            >
              <AddMember
                ref="AddMember"
                v-if="showAddMember"
                :postfix="postfix"
                :groupData="groupData"
                :isEditor="isEditor"
                :memberInfo="memberInfo"
                :reset-input="resetInput"
                @closeMemberShow="closeMemberShow"
                @showRoleDialog="showRoleDialog = true"
              >
              </AddMember>
              <div slot="footer">
                <template v-if="isEditor">
                  <w-button
                    type="primary"
                    size="small"
                    @click="handlerAddMember()"
                  >确定
                  </w-button
                  >
                  <w-button type="minor" @click="handlerClose">取消</w-button>
                </template>
                <template v-else>
                  <w-button
                    type="primary"
                    size="small"
                    @click="handlerAddMember(true)"
                  >创建并继续添加
                  </w-button
                  >
                  <w-button
                    type="primary"
                    size="small"
                    @click="handlerAddMember()"
                  >创建并关闭
                  </w-button
                  >
                </template>
              </div>
            </w-dialog>
            <!-- 重置密码 弹窗 -->
            <w-dialog
              @close="handleCancel"
              :show="visible"
              title="重置密码"
              :wallStyle="{ zIndex: 2001 }"
              :boxStyle="{ width: '410px', zIndex: 2001 }"
              :bodyStyle="{ padding: '24px 15px 0 15px' }"
            >
              <p class="padding-0-5">重置密码后请及时告知员工！</p>
              <div class="padding-20-0">
                <w-form
                  ref="passwordForm"
                  :model="passwordForm"
                  label-width="80px"
                  :rules="passwordRules"
                  label-position="left"
                >
                  <w-form-item label="新密码" prop="password">
                    <w-input
                      class="width-full"
                      type="password"
                      v-model.trim="passwordForm.password"
                      placeholder="请输入新密码"
                      autocomplete="new-password"
                    ></w-input>
                  </w-form-item>
                </w-form>
              </div>
              <div slot="footer">
                <w-button type="primary" size="small" @click="handleOk"
                >确定
                </w-button
                >
                <w-button type="minor" @click="handleCancel">取消</w-button>
              </div>
            </w-dialog>
            <!-- 查看权限弹窗 -->
            <w-dialog
              @close="showRoleDialog = false"
              :show="showRoleDialog"
              title="查看权限"
              :wallStyle="{ zIndex: 2001 }"
              :box-style="{ width: '1200px', zIndex: 2001 }"
              :bodyStyle="{ padding: 0 }"
            >
              <img
                src="@/assets/images/preview-role.png"
                width="100%"
                height="685"
                alt=""
              />
            </w-dialog>
            <!-- 批量添加员工 弹窗 -->
            <w-dialog
              :show="uploadVisible"
              @close="handleUploadCancel"
              class="add-members-batch"
              title="批量添加员工账号"
              :wallStyle="{ zIndex: 2001 }"
              :box-style="{ width: '500px', zIndex: 2001 }"
              :bodyStyle="{ padding: '24px' }"
              :footerStyle="{
                padding: '20px 24px 24px 24px',
                borderTop: 'none'
              }"
            >
              <div v-if="uploadVisible">
                <div class="suffix-reg-tip">
                  <p>1、姓名：方便企业员工间联系</p>
                  <p>
                    2、账号：员工唯一标识，可用于登录广联达产品，2-xx位字符，以字母开头，由字母、数字、_ 或 - 组成，建议使用组织内成员工号或姓名全拼，不填写则由系统自动生成，创建完成后无法修改
                  </p>
                  <p>3、初始密码：账号的登录密码，8-16位字符，以字母开头，由字母、符号组成，不填写则由系统自动生成</p>
                  <p>4、手机：可用于找回账号密码，享受广联达400服务，并可使用手机验证码快捷登录</p>
                  <p>5、账号及手机不可同已创建的账号，重复账号信息将自动过滤，请注意检查</p>
                  <p class="account-guide__wrapper">
                    <a
                      href="/doc/account_rights_guide.html"
                      @click="sentLog(100117044)"
                      target="_blank">点我了解企业员工账号特权及使用方法</a>
                  </p>
                </div>
                <div class="flex">
                  <div class="label">分组</div>
                  <div class="flex-1">
                    <w-cascader
                      v-model="uploadDepartmentId"
                      placeholder="请选择所属分组"
                      :props="{value:'departmentId',label:'departmentName',children:'subList',emitPath:false,checkStrictly:true}"
                      :show-all-levels="false"
                      :options="[{departmentId: 'null', departmentName: '全公司',parentId:'null', subList: [...this.groupData]}]"
                      filterable>
                    </w-cascader>
                    <!-- <w-select
                      v-model="uploadDepartmentId"
                      placeholder="请选择分组"
                      size="small"
                      style="width: 402px"
                      @change="changeGroup"
                    >
                      <w-option
                        style="width: 402px"
                        v-for="(item, index) in [
                          { departmentId: null, departmentName: '全公司' },
                          ...groupData
                        ]"
                        :key="index"
                        :label="item.departmentName"
                        :value="item.departmentId"
                      >
                      </w-option>
                    </w-select> -->
                  </div>
                </div>
                <div class="flex margin-top-24">
                  <div class="label">上传</div>
                  <div class="flex-1">
                    <div>
                      <div class="inline-block">
                        <div class="inline-block">
                          <w-button
                            @click="includeInput"
                            size="small"
                            type="primary"
                            icon="plus"
                            ghost
                          >文件上传
                          </w-button
                          >
                          <input
                            v-if="uploadVisible"
                            ref="excelInput"
                            @change="beforeUpload"
                            type="file"
                            accept
                            style="display: none"
                          />
                        </div>
                      </div>
                      <div class="upload-help-block">
                        请严格按照
                        <a
                          href="javascript: void(0);"
                          @click="downloadExcelTemplate"
                        >
                          批量添加员工账号Excel模板
                        </a>
                        上传，上限100
                      </div>
                    </div>
                    <p
                      class="margin-top-10"
                      v-for="(file, index) in fileList"
                      :key="index"
                    >
                      {{ file.name }}
                    </p>
                    <p
                      class="color-red padding-top-5"
                      v-if="uploadErrorMessage"
                    >
                      {{ uploadErrorMessage }}
                    </p>
                  </div>
                </div>
              </div>
              <div slot="footer">
                <w-button type="primary" size="small" @click="handleUpload"
                >确定
                </w-button
                >
                <w-button type="minor" @click="handleUploadCancel"
                >取消
                </w-button
                >
              </div>
            </w-dialog>
             <!-- 批量移动 弹窗 -->
             <w-dialog
              @close="handlerMoveClose"
              :show="showMoveMember"
              class="move-members-batch"
              title="移动到"
              :wallStyle="{ zIndex: 2001 }"
              :box-style="{ width: '460px', zIndex: 2001 }"
              :bodyStyle="{ height:'360px', padding: '9px 0px 0px 0px' }"
              :footerStyle="{
                padding: '2px 24px 24px 24px',
                borderTop: 'none'
              }"
            >
          <w-scrollbar
          wrap-style="overflow-x: hidden;"
          style="width: 100%; height: 98%; overflow-x: hidden"
        >
            <div class="group--all">
              <div
                :style="{ background:(departmentMoveName === '全公司'?'#F3F4F7':''),color:(departmentMoveName === '全公司'?'#2079FA':''),fontWeight:(departmentMoveName === '全公司'?'bold':'')}"
                class="group-name"  @click="clickMoveGroupNode({departmentId: null,departmentName: '全公司'})">
                <i style="fontSize:20px;margin-top:-5px;margin-left: 12px !important;"
                   class="r2-icon-nav_arrow_drop_down margin-left-0" :class="{expand: showMoveTreeAll}"
                   @click.stop="(showMoveTreeAll = !showMoveTreeAll)"></i>全公司
              </div>
              <collapse>
                <w-tree
                  :data="groupData"
                  v-show="showMoveTreeAll && groupData.length>0"
                  :props="defaultProps"
                  ref="moveTree"
                  :highlight-current="true"
                  :default-expand-all='isMoveExpand'
                  node-key="departmentId"
                  :expand-on-click-node="true"
                >
                  <div class="custom-tree-node" slot-scope="{ node, data}">
                    <div class="flex item-container" @click.stop="clickMoveGroupNode(data)">
                      <span class="organizationTitle" :title="node.label.length>8?node.label:''">{{ node.label }}</span>
                      <span @click.stop>
                    </span>
                    </div>
                  </div>
                </w-tree>
              </collapse>
            </div>
          </w-scrollbar>
              <div slot="footer">
                <template>
                  <w-button
                    type="primary"
                    size="small"
                    @click="handlerMoveMember()"
                  >确定
                  </w-button
                  >
                  <w-button type="minor" @click="handlerMoveClose">取消</w-button>
                </template>
              </div>
            </w-dialog>
            <config-asset
              v-if="showConfigAsset"
              :refresh-index="showConfigAsset"
              :config-item="configItem"
              @submit="onConfigSubmit"
              @cancel="onConfigCancel"
            >
            </config-asset>
            <config-lent
              v-if="showConfigLent"
              :refresh-index="showConfigLent"
              :config-item="configItem"
              @submit="onConfigSubmit"
              @cancel="onConfigCancel"
            >
            </config-lent>
            <!-- 可配置的资产编号授权为0，无法配置资产。 -->
            <w-dialog
              :show="showConfigAssetAfterAddUser"
              confirm
              show-close
              class="no-asset-model"
              :box-style="{ width: '500px' }"
              title="温馨提示"
              @close="showConfigAssetAfterAddUser = false"
            >
              <div class="padding-20-0">是否直接进行配置资产操作?</div>
              <template slot="footer">
                <w-button
                  type="primary"
                  @click="handlerAction({ type: 'config' })"
                  size="small"
                >确定
                </w-button
                >
                <w-button
                  type="minor"
                  @click="showConfigAssetAfterAddUser = false"
                  size="small"
                >取消
                </w-button
                >
              </template>
            </w-dialog>
            <!--一键创建员工-->
            <!--
            <w-dialog
              :show="showFastAddMembers"
              confirm
              show-close
              :box-style="{ width: '460px' }"
              title="一键创建员工"
              @close="showFastAddMembers = false"
            >
              <div class="padding-20-0">
                <fast-add-member
                  v-if="showFastAddMembers"
                  ref="fastAddMembers"
                  :assetsNumber="assetsNumber"
                  @submit="submitFastAddMembers"
                ></fast-add-member>
              </div>
              <template slot="footer">
                <w-button
                  type="primary"
                  :disabled="waitingCreated"
                  @click="handlerFastAddMembers()"
                  size="small"
                >确定
                </w-button
                >
                <w-button
                  type="minor"
                  @click="showFastAddMembers = false"
                  size="small"
                >取消
                </w-button
                >
              </template>
            </w-dialog>
            <w-dialog
              :show="showFastAddSuccess"
              confirm
              show-close
              :box-style="{ width: '300px' }"
              :bodyStyle="{ padding: 0 }"
              @close="showFastAddSuccess = false"
            >
              <div
                class="text-align-center"
                style="padding: 44px 34px 40px 34px"
              >
                <div class="text-align-center" style="height: 72px">
                  <div
                    class="inline-block"
                    style="
                      width: 72px;
                      height: 72px;
                      background: #00c461;
                      border-radius: 50%;
                    "
                  >
                    <i
                      class="r2-icon-nav_check inline-block"
                      style="color: #ffffff; font-size: 48px"
                    ></i>
                  </div>
                </div>
                <div
                  style="
                    height: 32px;
                    font-size: 24px;
                    font-weight: 500;
                    color: #212530;
                    line-height: 32px;
                    margin-top: 32px;
                  "
                >
                  添加成功
                </div>
                <div style="margin: 16px 0 37px 0">
                  自动添加成员成功，此次自动添加了{{ accountNum }}个账号，
                  <span class="bold">账号密码同员工账号</span>
                  <template v-if="assetNum">
                    <span class="bold"
                    >，为您的前{{ assetNum }}个账号配置了资产，</span
                    >
                    详情可在人员列表查看
                  </template>
                </div>
                <div>
                  <w-button
                    type="primary"
                    @click="closeSuccessDialog()"
                    size="small"
                  >确定
                  </w-button
                  >
                </div>
              </div>
            </w-dialog>
            -->
          </div>
        </div>
        <router-view :table-height="tableHeight" :table-width="tableWidth - 10"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import AddMember from './AddMember'
// import fastAddMember from './component/fastAddMembers'
import ConfigAsset from '_c/manage/ConfigAsset.vue'
import ConfigLent from '_c/manage/ConfigLent.vue'
import {mapState, mapActions, mapMutations} from 'vuex'
import {on, off, isEmptyObject, clone, sizeConver} from '@/assets/utils'
import {getCookie} from '@/assets/utils/CommonUtil'
import {Collapse} from '@/components/common'
import manageService from '@/assets/service/manage'
import _ from 'lodash'
import api from 'service'
// import noDataVue from '../../workbench/component/no-data.vue'

let captchaIns

export default {
  name: 'ManageMembers',
  components: {
    AddMember,
    // fastAddMember,
    Collapse,
    ConfigAsset,
    ConfigLent
  },
  data () {
    const validateSuffix = (rule, value = '', callback) => {
      if (typeof value === 'string' && value.trim() === '') {
        callback(new Error('不能为空！'))
      } else if (!/^[A-Za-z0-9]+$/.test(value)) {
        return callback(new Error('只能包含字母、数字'))
      } else if (value.length < 3) {
        return callback(new Error('长度不能少于3个字符'))
      } else if (value.length > 15) {
        return callback(new Error('长度不能超过15个字符'))
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value = '', callback) => {
      if (
        value === '' ||
        !/(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^[^\s\u4e00-\u9fa5]{8,16}$/.test(
          value
        )
      ) {
        callback(new Error('请输入8-16位密码，数字、字母和符号至少包含两种'))
      } else {
        callback()
      }
    }

    return {
      isExpand: true, // 是否默认展开所有节点
      defaultProps: {
        children: 'subList',
        label: 'departmentName'
      },
      organizationData: {departmentName: null, departmentId: null},
      istrue: true,
      tableWidth: 0,
      tableHeight: 0,
      showAll: true,
      currentGroup: {},
      groupData: [],
      groupName: [], // 最高级组织名称
      subListGroupName: [], // 当前新增子组织的父级
      uploadDepartmentId: null,
      uploadVisible: false,
      uploadErrorMessage: '',
      uploading: false,
      fileList: [],
      selectType: 'userName',
      fuuzzySearch: '',
      loading: false,
      showRoleDialog: false, // 角色权限弹窗
      roleList: [
        {
          roleId: 2,
          name: '总负责人'
        },
        {
          roleId: 4,
          name: '普通员工'
        }
      ],
      roleMap: {
        2: '总负责人',
        4: '普通员工'
      },
      scrollY: false,
      data: [],
      departmentId: null,
      departmentName: '全公司',
      currentRow: {},
      pagination: {
        total: 0,
        current: 1,
        pageNum: 1,
        pageSize: 50,
        defaultPageSize: 50,
        pageSizeOptions: ['50', '100'],
        showSizeChanger: true,
        showQuickJumper: true,
        hideOnSinglePage: true
      },
      showSetSuffix: false, // 新建后缀
      suffixForm: {
        suffix: '' // 后缀内容
      },
      suffixRules: {
        suffix: [
          {required: true, validator: validateSuffix, trigger: 'blur'}
        ]
      },
      suffixValidateMessage: '', // 后缀错误信息
      postfix: '', // 企业后缀 编辑员工账号 时 才显示账号输入项 会有企业后缀
      showAddMember: false,
      showConfigAsset: 0, // 显示 "配置资产" 弹窗
      showConfigLent: 0, // 显示 "设置借出" 弹窗
      configItem: {}, // 正在执行 配置资产、设置借出 的行数据
      memberInfo: {},
      captchaId: 'f48c8384d76e43669e25f1f9f95ecbfc',
      validate: '',
      isEditor: false,
      visible: false,
      confirmLoading: false,
      passwordForm: {
        password: ''
      },
      passwordRules: {
        password: [{validator: validatePassword, trigger: 'blur'}]
      },
      showConfigAssetAfterAddUser: false, // 单个添加员工后  若 企业有可配置资产 显示是否直接对此员工进行资产配置 提示弹窗
      showMemTips: false, // 是否展示引导提示
      resetInput: 0, // 是否触发清空 添加员工账号 弹窗输入项
      addAnother: false, // 添加员工弹窗 是否创建另一个
      showFastAddMembers: false, // 一键创建员工弹窗
      waitingCreated: false,
      assetsNumber: 0,
      accountNum: 0, // 成功创建员工数
      assetNum: 0, // 成功配置资产数
      showFastAddSuccess: false,
      checkAll: false, // 复选框全选状态
      isIndeterminate: false, // 选中单个之后全选框状态
      showMoveMember: false,
      showMoveTreeAll: true,
      departmentMoveName: '全公司',
      isMoveExpand: true, // 是否默认展开批量移动树所有节点
      selectedAccountArr: [],
      excludeRoleIdMember: true,
      extrasInfo: true,
      showFrozenTip: false // 是否展示已冻结引导提示
    }
  },
  computed: {
    ...mapState({
      assetLeftOver: state => state.members.assetLeftOver,
      foldMenu: state => state.menus.foldMenu, // 是否折叠菜单
      showRoleTip: state => state.members.isGuide // 是否展示缺少总负责人提示
    }),
    // 显示已删除人员列表
    showDeletedStaff () {
      return /^\/manage\/members\/deleted/.test(this.$route.path)
    },
    // 显示跨组织关系列表
    showOrganization () {
      return /^\/manage\/members\/organization/.test(this.$route.path)
    },
    // 显示已冻结账号列表
    showFrozenAccount () {
      return /^\/manage\/members\/frozen/.test(this.$route.path)
    }
  },
  filters: {
    permissionFilter (data) {
      let arr = []
      data.map(module => {
        if (module.check) {
          arr.push(module.description)
        }
      })
      return arr.join('、') || '无'
    }
  },
  created () {
    let that = this
    window.initNECaptcha(
      {
        element: '#captcha', // 验证码容器元素ID
        captchaId: that.captchaId, // 由用户中心分配
        mode: 'bind',
        // mode: 'popup',
        width: '320px',
        // enableClose: true, // 由业务方控制验证码弹框关闭
        // feedbackEnable: false, // 业务方关闭反馈入口
        onVerify (err, data) {
          // 用户验证码验证成功后，进行实际的提交行为
          if (data) {
            that.verifyCallback({
              validate: data.validate,
              captchaId: that.captchaId
            })
            // captchaIns.refresh();
          }
          console.log(err)
        }
      },
      instance => {
        // 初始化成功后得到验证实例instance，可以调用实例的方法
        captchaIns = instance
      },
      err => {
        // 初始化失败后触发该函数，err对象描述当前错误信息
        console.log(err)
      }
    )
    // 查询是否存在总负责人
    if (this.showRoleTip === false) {
      manageService
        .getRole({token: getCookie('ZJYTOKEN'), users: [2]})
        .then(res => {
          console.log('data: \n' + res)
          let data = res.data || []
          if (data.length === 0) {
            this.setGuide(1)
          }
        })
    }
    this.isExpand = false
  },
  mounted () {
    // this.updateMenuStatus(true)

    // on(window, 'click', this._clickHandle)
    on(this.$refs.bodyWrapper, 'scroll', this.handleScroll)
    // 设置报表高度
    this.resizeHandle.resize(() => {
      setTimeout(() => {
        this.calcTableHeight()
      }, 100)
    })
    setTimeout(() => {
      this.calcTableHeight()
    }, 200)
    this.getDepartmentList()
    this.initFrozenTip()
    // this.getEmployeePostfix()
    if (!this.showDeletedStaff) {
      if (this.$route.query && this.$route.query.departmentId) {
        this.getEmployeeList({departmentId: this.$route.query.departmentId, fnCode: 100117002})
        this.departmentName = this.$route.query.departmentName
      } else {
        this.getEmployeeList({fnCode: 100117002})
      }
    }
  },
  updated () {
    let scrollY
    try {
      scrollY =
        this.$refs.containerWrapper.clientHeight >
        this.$refs.bodyWrapper.clientHeight
    } catch (e) {
      scrollY = false
    }
    this.scrollY = scrollY
    scrollY && this.calcTableHeight()
  },
  beforeDestroy () {
    captchaIns = null
    // off(window, 'click', this._clickHandle)
    off(this.$refs.bodyWrapper, 'scroll', this.handleScroll)
  },
  methods: {
    ...mapActions({
      getAssetList: 'members/getAssetList'
    }),
    ...mapMutations({
      setGuide: 'members/SET_GUIDE',
      updateMenuStatus: 'menus/SET_MENUS_STATUS'
    }),
    // 切换搜索类型
    changeSearchType (type) {
      if (type === 'productName') {
        this.sentLog(100117078)
      }
    },
    beforeHandleCommand (data, command) {
      return {
        'data': data,
        'command': command
      }
    },
    handleCommand (command) {
      command.command === 'edit' ? this.organizationEdit(command.data) : ''
      command.command === 'add' ? this.organizationAdd(command.data) : ''
      command.command === 'delete' ? this.organizationDelete(command.data) : ''
    },
    // 重命名组织名称
    organizationEdit (data) {
      data.isEditor = true
    },
    // 新增组织
    organizationAdd (data) {
      // console.log(data)
      // 如果是在已有组织节点新增子部门，把当前组织所有的children存放在subListGroupName中，用于后边判断是否已经存在同名部门
      data.subList.forEach(ele => {
        this.subListGroupName.push(ele.departmentName)
      })
      const newChild = {
        departmentName: null,
        subList: [],
        isEditor: true,
        departmentId: null,
        parentId: data.departmentId,
        groupValidateError: false
      }
      if (!data.subList) {
        this.$set(data, 'subList', [])
      }

      data.subList.push(newChild)

      this.$refs.tree.store.nodesMap[data.departmentId].expanded = true

      setTimeout(() => {
        console.log(this.$refs)
        this.$refs['focusInput'].focus()
      }, 300)
      // console.log(this.$refs.tree.store.nodesMap[data.departmentId].childNodes)
    },
    // 新增编辑输入框失焦
    organizationBlur (data) {
      // console.log('输入框', data, data.parentId)

      // 用于删除无效dom
      const findObj = (arr) => {
        arr.forEach((ele, index) => {
          if (ele.subList.length > 0) {
            if (ele.departmentId === data.parentId) {
              // console.log('找到当前要删除的对象：', ele)
              var curIndex = ele.subList.findIndex((value, index, arr) => {
                return value.departmentName === null
              })
              ele.subList.splice(curIndex, 1)
            }
            findObj(ele.subList)
          }
        })
      }
      if (data.departmentName === '' || data.departmentName === null) {
        if (data.parentId === undefined) {
          // 新增最外层分组名称
          this.groupData.pop()
        }
        if (data.departmentId !== null) {
          // 修改最外层分组名称---判断是新增的还是编辑的
          data.departmentName = data.content
          data.isEditor = false
          data.hover = false
          // this.$message.error('分组名称不能为空')
          // this.handlerCommitGroup(data)
        } else {
          // 删除已存在组织下的空dom
          findObj(this.groupData)
        }
      } else {

        if (data.content === data.departmentName) { // 组织名称不变
          data.departmentName = data.content
          data.isEditor = false
          data.hover = false
        } else {

          if (data.parentId !== undefined) { // 判断是新增最高级部门还是子部门-子部门

            if (this.subListGroupName.includes(data.departmentName)) { // subList是否有同名
              this.sentLog(100117055, {status: 2})

              findObj(this.groupData)
              this.$message.error('已有同名组织！')
            } else {
              this.handlerCommitGroup(data)
            }
          } else if (data.parentId === undefined) { // 判断是新增最高级还是子集-最高级
            console.log('this.groupName', this.groupName, this.groupName.includes(data.departmentName))
            if (this.groupName.includes(data.departmentName)) {
              this.sentLog(100117055, {status: 2})

              this.groupData.pop()
              this.$message.error('已有同名组织！')
            } else {
              this.handlerCommitGroup(data)

            }
          }
        }
      }

    },
    // 删除组织
    organizationDelete (data) {
      console.log(data)
      if (data.subList.length > 0) {
        this.$message.error('该分组下有组织，不予删除！')
        this.sentLog(100117058, {status: 2})
      } else {
        this.handlerDeleteGroup(data)
      }
    },

    // // 设置权限
    // updateManageHandle (child, {gldUserId: id, account}) {
    //   this.sentLog(100117052, {permission: child.description})
    //   if (child.check) {
    //     manageService
    //       .addPermission(id, [child.roleCode])
    //       .then(res => {
    //         if (res.code !== 200) {
    //           this.$message.error(res.message)
    //           child.check = false
    //         } else {
    //           manageService.addRelationLog({
    //             area: this.userInStore.area,
    //             detail: `${account}被修改管理权限`,
    //             operateType: 'EDIT_ACCOUNT',
    //             relType: '',
    //             showState: 1
    //           })
    //         }
    //       })
    //       .catch(_ => {
    //         this.$message.error('设置权限错误')
    //         child.check = false
    //       })
    //   } else {
    //     manageService
    //       .deletePermission(id, [child.roleCode])
    //       .then(res => {
    //         if (res.code !== 200) {
    //           this.$message.error(res.message)
    //           child.check = true
    //         } else {
    //           manageService.addRelationLog({
    //             area: this.userInStore.area,
    //             detail: `${account}被修改管理权限`,
    //             operateType: 'EDIT_ACCOUNT',
    //             relType: '',
    //             showState: 1
    //           })
    //         }
    //       })
    //       .catch(_ => {
    //         this.$message.error('设置权限错误')
    //         child.check = true
    //       })
    //   }
    // },
    // 计算表格宽高
    calcTableHeight () {
      let tableWidth = 800
      // if (mainContent && mainContent.clientWidth) {
      //   tableWidth = mainContent.clientWidth - 58
      // }
      if (tableWidth < this.getDomWidth('scrollBody')) {
        tableWidth = this.getDomWidth('scrollBody')
      }
      if (this.scrollY) {
        tableWidth -= 6
      }
      console.log(tableWidth)
      this.tableWidth = tableWidth
      this.tableHeight =
        this.getTableHeight('table-container') -
        96 -
        (this.data.length ? 37 : 0)
    },
    // 滚动条滚动事件
    handleScroll (event) {
      this.$refs.headerWrapper.scrollLeft = this.$refs.bodyWrapper.scrollLeft
    },
    // 获取分组列表
    getDepartmentList () {
      this.groupData = []
      manageService.getDepartmentList().then(res => {
        if (res.code === 200) {
          let groupData = res.data || []
          let groupName = []

          groupData.forEach(item => {
            groupName.push(item.departmentName)
          })
          const formatData = (arr) => {
            arr.forEach((ele, index) => {
              ele.isEditor = false
              ele.hover = false
              ele.content = ele.departmentName
              ele.groupValidateError = false
              ele.groupValidateMessage = ''

              if (ele.subList.length > 0) {
                formatData(ele.subList)
              }
            })
          }
          formatData(groupData)
          this.groupData = groupData
          this.groupName = groupName

        }
      })
    },
    // 添加分组-最高级
    handlerAdd () {
      this.groupData.push({
        departmentName: null,
        subList: [],
        isEditor: true,
        departmentId: null,
        groupValidateError: false,
        groupValidateMessage: ''
      })
    },
    // 提交分组
    handlerCommitGroup (item) {
      console.log('提交的数据', item)
      let {departmentName} = item
      if (departmentName === '' || departmentName === null) {
        // item.groupValidateError = true
        // item.groupValidateMessage = '分组名称不能为空'
        this.$message.error('分组名称不能为空')
      } else if (!/^[\u4e00-\u9fa5A-Za-z0-9-_]+$/.test(departmentName)) {
        item.groupValidateError = true
        item.groupValidateMessage =
          '分组名称只能输入中文、英文、数字、下划线和横杠'
        this.sentLog(100117056, {status: 2})
        // this.$message.error('分组名称只能输入中文、英文、数字、下划线和横杠')
      } else if (departmentName.length > 30) {
        item.groupValidateError = true
        item.groupValidateMessage = '分组名称不能超过30'
        // this.$message.error('分组名称不能超过30')
      } else {
        // item.isEditor = false;
        item.groupValidateMessage = ''
        // 存储
        this.commitGroup(item)
      }
    },
    // 编辑分组
    handlerEditorGroup (item) {
      item.isEditor = true
    },
    // 删除分组
    handlerDeleteGroup ({departmentId}) {
      manageService.deleteDepartment({departmentId}).then(res => {
        if (res.code === 200) {
          // this.$message.success('删除成功！')
          // this.departmentName = '全公司'
          console.log(departmentId === this.departmentId)
          if (departmentId === this.departmentId) {
            this.departmentName = '全公司'
            this.getEmployeeList()
          }
          this.getDepartmentList()
          this.sentLog(100117058, {status: 1})
        } else {
          this.$message.error(res.message)
          this.sentLog(100117058, {status: 2})
        }
      })
    },
    // 关闭右键菜单
    _clickHandle () {
      let groupData = this.groupData || []
      groupData.forEach((item, index) => {
        let {isEditor = false, departmentName = '', content = ''} = item
        if (isEditor) {
          if (departmentName === '' && content === '') {
            this.groupData.splice(index, 1)
            item.groupValidateError = false
            item.groupValidateMessage = ''
          } else {
            if (departmentName === '' && content) {
              item.departmentName = content
            }
            this.handlerCommitGroup(item)
          }
        }
      })
    },
    // 分组点击事件
    clickGroupNode ({departmentId, departmentName}) {
      console.log(departmentId !== undefined)
      this.$refs.tree.setCurrentKey(departmentId)
      if (departmentId !== undefined) {
        this.pagination.pageSize = 50
        this.pagination.pageNum = 1
        this.getEmployeeList({departmentId})

        this.departmentId = departmentId
        this.departmentName = departmentName
        this.$router.push({
          path: '/manage/members',
          query: {departmentId, departmentName}
        })
      }
    },
    // 发起请求
    commitGroup (item) {
      let {departmentId, departmentName, parentId} = item
      let params = {departmentName: encodeURIComponent(departmentName)}
      let fn = 'addDepartment'

      if (departmentId) {
        fn = 'editDepartment'
        params.departmentId = departmentId
      }
      if (parentId !== null && parentId !== undefined) {
        // 新增子部门
        params.parentId = parentId
      } else if (parentId === undefined) {
        // 新增最高级分组
        params.parentId = null
      } else {
        params.departmentId = departmentId
        fn = 'editDepartment'
      }
      // debugger
      // console.log('提交内容：', fn, params)
      manageService[fn](params).then(res => {
        // const findLevel = (data) => {
        //   data.forEach((ele, index) => {
        //     if (ele.subList.length > 0){
        //       findLevel(ele.subList)
        //     } else {
        //       if (ele.departmentId === parentId){
        //         return index + 1
        //       }
        //     }
        //   })
        // }
        if (res.code === 200) {
          // this.$message.success('操作成功！')
          console.log(fn, fn === 'addDepartment', fn === 'editDepartment', this.groupData)

          if (fn === 'addDepartment') {
            this.sentLog(100117055, {status: 1})
          }

          if (fn === 'editDepartment') {
            this.sentLog(100117056, {status: 1})
          }
          if (parentId !== null && parentId !== undefined) {
            // const level = findLevel(this.groupData)
            const level = this.$refs.tree.store.nodesMap[departmentId].level + 1
            this.sentLog(100117057, {status: 1, level: level})
          }
          this.$refs.tree.setCurrentKey(departmentId)
          this.getDepartmentList()
        } else {
          this.$message.error(res.message)
          if (fn === 'addDepartment') {
            this.sentLog(100117055, {status: 2})
          }
          if (fn === 'editDepartment') {
            this.sentLog(100117056, {status: 2})
          }
          if (parentId !== null && parentId !== undefined) {
            // const level = findLevel(this.groupData)
            const level = this.$refs.tree.store.nodesMap[departmentId].level + 1
            this.sentLog(100117057, {status: 2, level: level})
          }
        }
      })
    },
    // 显示 已删除人员 列表
    showDeletedStaffList () {
      this.$router.push({path: '/manage/members/deleted'})
      this.sentLog(100117035)
    },
    // 显示 已冻结账号 列表
    showFrozenAccountList () {
      this.$router.push({path: '/manage/members/frozen'})
    },
    // 显示跨组织关系列表
    // showOrganizationList () {
    //   this.sentLog(100117080)
    //   this.$router.push({
    //     path: '/manage/members/organization'
    //   })
    // },
    // 获取企业后缀
    getEmployeePostfix (cb) {
      manageService.getEmployeePostfix().then(res => {
        const postfix = res.data || ''
        if (res.code === 200 && postfix) {
          this.postfix = postfix
          typeof cb === 'function' && cb()
        } else {
          // 设置企业后缀
          this.showSetSuffix = true
          // errFunc()
        }
      })
    },
    // 后缀弹窗-点击确定
    handlerSetSuffix () {
      this.$refs.suffixForm.validate((valid) => {
        if (valid) {
          manageService.setEmployeePostfix({postfix: this.suffixForm.suffix}).then(res => {
            if (res.code === 200) {
              this.postfix = this.suffixForm.suffix
              this.handleCloseSuffix()
            } else {
              this.suffixValidateMessage = res.message
            }
          })
        }
      })
    },
    // 后缀弹窗-点击取消
    handleCloseSuffix () {
      this.$refs.suffixForm.resetFields()
      this.showSetSuffix = false
      this.suffixValidateMessage = ''
    },
    // 获取员工列表
    getEmployeeList: _.debounce(function (condition = {}) {
      const {departmentId = '', fnCode = ''} = condition
      let {pagination, fuuzzySearch, selectType, excludeRoleIdMember, extrasInfo} = this
      let params = {
        departmentId,
        pageNum: pagination.pageNum,
        pageSize: pagination.pageSize,
        excludeRoleIdMember,
        extrasInfo
      }
      if (selectType === 'userName') {
        params.fuuzzySearch = fuuzzySearch
      } else if (selectType === 'productName') {
        params.productName = fuuzzySearch
      }
      this.loading = true
      const s = Date.now()
      manageService
        .getEmployeeList(params)
        .then(res => {
          this.loading = false
          let data = res.data || {}
          let {items = [], total = 0} = data
          items.forEach(item => {
            item.size = sizeConver(item.workspaceCapacity || 0)
            // item.assetNums = Object.keys(item.assetToDetail)
            // 隐藏选项-企业材料、指标库、计价依据库管理权
            item.enterpriseDBManagerList = (item.enterpriseDBManagerList || []).filter(i => !['ROLE_QYDB_CL', 'ROLE_QYDB_ZB', 'ROLE_QYDB_YJ'].includes(i.roleCode))
            item.checkbox = false
            item.departmentNameVal = this.getDepartmentName(item.departmentId)
          })
          this.data = items
          if (res.code === 200) {
            this.initTips()
            this.calcTableHeight()
          }
          this.pagination.total = total
          this.checkAll = false
          this.isIndeterminate = false
          this.selectedAccountArr = []
          // 渲染完成后，发送埋点
          this.$nextTick(() => {
            if (fnCode) {
              this.sentLog(fnCode, {message: fuuzzySearch, duration: ((Date.now() - s) / 1000).toFixed(2)})
            }
          })
        })
        .catch(() => {
          this.loading = false
          this.data = []
          this.pagination.total = 0
          this.pagination.current = 1
          this.checkAll = false
          this.isIndeterminate = false
          this.selectedAccountArr = []
        })
    }, 300),
    // 分页
    handleCurrentChange (index) {
      this.pagination.pageNum = index
      this.getEmployeeList({departmentId: this.departmentId})
    },
    // 更改页显示多少
    handlePageSizeChange (index) {
      this.pagination.pageSize = index
      this.pagination.pageNum = 1
      this.getEmployeeList({departmentId: this.departmentId})
    },
    // 搜索
    handlerSearch () {
      // this.sentLog(100117013, {message: this.keyword})
      this.pagination.current = 1
      this.getEmployeeList({departmentId: this.departmentId, fnCode: 100117013})
    },
    // 调用查询接口
    handleTableChange (pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      // this.queryParam.pageNum = pagination.current;
      // this.queryParam.pageSize = pagination.pageSize;
      this.getEmployeeList()
    },
    // 邀请成员加入企业
    inviteMembers () {
      this.getEmployeePostfix(() => {
        this.$showInvite()
      })
    },
    // 一键创建员工
    fastAddMember () {
      manageService
        .assetsNumber()
        .then(res => {
          if (res.code === 200) {
            this.assetsNumber = res.data || 0
            this.showFastAddMembers = true
          }
        })
        .catch(() => {
          this.assetsNumber = 0
          this.showFastAddMembers = true
        })
    },
    // 一键创建员工-确定
    handlerFastAddMembers () {
      this.$refs.fastAddMembers.submitForm()
      // this.showFastAddMembers = false
      // this.showFastAddSuccess = true
    },
    // 提交一键创建并配置资产
    submitFastAddMembers (params) {
      params.departmentId = this.departmentId
      this.waitingCreated = true
      manageService
        .createAndConfigAssets(params)
        .then(res => {
          this.waitingCreated = false
          if (res.code === 200) {
            this.showFastAddMembers = false
            this.showFastAddSuccess = true
            const {accountNum, assetNum} = res.data || {}
            this.accountNum = accountNum // 成功创建员工数
            this.assetNum = assetNum // 成功配置资产数
            this.sentLog(100117042, {status: 1})
            this.departmentName = '全公司'
          } else {
            this.$message.error(res.message || '自动创建失败，请重新再试')
            this.sentLog(100117042, {status: 2})
          }
        })
        .catch(() => {
          this.waitingCreated = false
          this.sentLog(100117042, {status: 2})
        })
    },
    // 企业数据看板复选框变化
    dashboardAuthority (item) {
      console.log(item)
      // let params = {
      //   gldUserId: item.gldUserId,
      //   readStatus: item.canReadEnterpriseWorkbench
      // }
      // manageService.setDashboardAuthority(params)
      //   .then(res => {
      //     if (res.code === 200) {
      //       // this.$message.success('取消该人员企业数据看板权限成功!')
      //       this.sentLog(100117054, {status: 1})
      //     } else {
      //       this.$message.error('操作失败!')
      //       this.sentLog(100117054, {status: 2})
      //     }
      //   })
    },
    // 关闭一键创建成功弹窗
    closeSuccessDialog () {
      this.showFastAddSuccess = false
      this.pagination.pageNum = 1
      this.getEmployeeList()
    },
    // 添加成员
    addMember () {
      this.sentLog(100118007)
      this.getEmployeePostfix(() => {
        this.isEditor = false
        this.showAddMember = true
        this.memberInfo = {}
      })
    },
    // 批量添加
    batchAddMember () {
      this.sentLog(100117009)
      this.getEmployeePostfix(() => {
        this.uploadVisible = true
      })
    },
    // 确定添加员工弹窗
    handlerAddMember (addAnother) {
      this.addAnother = addAnother
      this.$refs.AddMember.submit()
    },
    // 关闭添加员工弹窗
    handlerClose () {
      this.memberInfo = {}
      this.$refs.AddMember && this.$refs.AddMember.close()
    },
    // 员工弹窗关闭回调
    closeMemberShow (memberInfo) {
      if (isEmptyObject(memberInfo)) {
        this.showAddMember = false
      } else {
        this.memberInfo = memberInfo
        captchaIns && captchaIns.verify() // 手动调用verify方法
      }
    },
    // 网易易顿回调
    verifyCallback (verifyOptions = {}) {
      let that = this
      let {
        showAddMember = false,
        uploadVisible = false,
        memberInfo = {},
        isEditor = false,
        showMoveMember = false
      } = that
      captchaIns && captchaIns.refresh()
      // 添加编辑员工
      if (showAddMember) {
        let {originRole, role, force} = memberInfo
        Object.assign(memberInfo, verifyOptions, {
          force: force || originRole === role
        })
        if (isEditor) {
          if ([2].includes(originRole) && role === 4) {
            // let suffix = `@${this.postfix}`
            // that.$confirm({
            //   type: 'warning',
            //   message: `您确定要将<span class="color-blue">${account +
            //     suffix}</span>更改成【普通员工】角色吗？ 更改后此员工将不再担任【总负责人】的角色。`,
            //   submitText: '确定',
            //   cancelText: '取消',
            //   submit () {
            //     that.operatorEmployee(memberInfo, 'editEmployee')
            //   },
            //   cancel () {
            //     // that.handlerClose();
            //   }
            // })
            that.operatorEmployee(memberInfo, 'editEmployee')
          } else {
            that.operatorEmployee(memberInfo, 'editEmployee')
          }
        } else {
          that.operatorEmployee(memberInfo, 'addEmployee')
        }
      }
      // 批量添加员工
      if (uploadVisible) {
        that.addBatchEmployee(verifyOptions)
      }
      // 批量移动员工
      if (showMoveMember){
        that.moveRelationBatch(verifyOptions)
      }
    },
    // 查询角色
    getRole (params, fn) {
      let that = this
      manageService.getRole({role: 2}).then(res => {
        if (res.code === 200) {
          if (isEmptyObject(res.data)) {
            // that.$confirm({
            //   type: 'warning',
            //   message: `您确定要将${params.name}设置成【总负责人】角色吗？`,
            //   submitText: '确定',
            //   cancelText: '取消',
            //   submit () {
            //     params.force = true
            //     that.operatorEmployee(params, fn)
            //   },
            //   cancel () {
            //     that.operatorEmployee(params, fn)
            //   }
            // })
            params.force = true
            that.operatorEmployee(params, fn)
          } else {
            that.operatorEmployee(params, fn)
          }
        }
      })
    },
    // 添加员工后 若企业下有可配置资产 弹窗提示是否去配置资产
    afterAddEmployee (nowUser) {
      this.getAssetList(nowUser)
        .then(() => {
          this.handlerClose()
          if (this.assetLeftOver) {
            this.configItem = nowUser
            this.showConfigAssetAfterAddUser = true // 显示 温馨提示  是否直接进行配置资产操作?
          }
        })
        .catch(e => {
          console.log(e)
          this.handlerClose()
        })
    },
    // 操作员工，接口请求
    operatorEmployee (params, fn) {
      let suffix = this.postfix ? `@${this.postfix}` : ''
      const {
        account,
        password,
        captchaId,
        departmentId,
        force,
        gldUserId,
        name,
        originRole,
        passwordMobile,
        role,
        validate
      } = params
      let postParams = {}
      switch (fn) {
        case 'addEmployee':
          postParams = {
            captchaId,
            departmentId,
            force,
            name,
            passwordMobile,
            role,
            validate
          }
          if (account) {
            postParams.account = account
          }
          if (password) {
            postParams.password = password
          }
          break
        case 'editEmployee':
          postParams = {
            account,
            captchaId,
            departmentId,
            force,
            gldUserId,
            name,
            originRole,
            passwordMobile,
            role,
            validate
          }
          break
        default:
          postParams = params
      }
      manageService[fn](postParams).then(res => {
        let message = ''
        // let status = 2
        switch (+res.code) {
          case 200: // 添加、编辑员工成功
            manageService.addRelationLog({
              area: this.userInStore.area,
              detail: fn === 'addEmployee' ? (((res.data || {}).success || {}).account || '') : `${account}${suffix}被编辑信息`,
              operateType: fn === 'addEmployee' ? 'CREATE_ACCOUNT' : 'EDIT_ACCOUNT',
              relType: '',
              showState: 1
            })
            // status = 1
            // 总负责人资产提示：----资产相关紧急输入注释提示
            // if (role === 2) {
            //   this.recommendProducts(gldUserId)
            // }
            if (res.data && fn === 'addEmployee' && !this.isEditor && res.data.success) {
              if (this.addAnother) {
                // 创建并继续添加
                this.resetInput++ // 清空添加员工 弹窗 输入项
              } else {
                // 创建并关闭
                // 添加单个员工成功后 若企业下有可配置资产 弹出温馨提示 是否直接进行配置资产操作?
                this.afterAddEmployee(res.data.success)
              }
            } else {
              this.handlerClose()
            }
            if (fn === 'addEmployee') {
              this.$message.success('员工添加成功，将会短信通知账号')
            }
            if (postParams.departmentId !== 'null') {
              this.getEmployeeList({departmentId: postParams.departmentId})

            } else {
              this.getEmployeeList()
              this.departmentName = '全公司'
            }

            this.$message.success('岗位设置成功')

            break
          case 330001:
            message =
              res.message || `${this.isEditor ? '编辑' : '添加'}员工失败`
            this.$message.error(message)
            break
          case 330002: // 总负责人已存在
            message = '总负责人已存在，设置新的总负责人二次确认'
            let {managerUserName = ''} = res.data
            this.$confirm({
              type: 'warning',
              message: `您确定要将<a class="color-blue">${(this.isEditor
                ? params.account
                : params.passwordMobile) +
              suffix}</a>更改成【总负责人】角色吗？ 更改后，原总负责人<span class="color-blue">${managerUserName}</span>将变成【普通员工】角色。`,
              submitText: '确定',
              cancelText: '取消',
              submit: () => {
                params.force = true
                this.closeMemberShow(params)
              }
            })
            break
          case 330005:
            message = res.message || '账号已存在'
            this.$message.error(message)
            break
          case 330013: // 总负责人不存在 设置成 总负责人 二次确认
            if ([2].includes(params.role)) {
              message = '设置成总负责人二次确认'
              const nowAccount = suffix
                ? (this.isEditor ? params.account : params.passwordMobile) +
                suffix
                : params.name
              this.$confirm({
                type: 'warning',
                message: `您确定要将<a class="color-blue">${nowAccount}</a>设置成【总负责人】角色吗？`,
                submitText: '确定',
                cancelText: '取消',
                submit: () => {
                  params.force = true
                  this.closeMemberShow(params)
                }
              })
            }
            break
          case 330019:
            message = '设置角色失败，用户正在登录'
            this.$message.error(message)
            break
          default:
            message = res.message || '操作失败'
            this.$message.error(message)
        }
        switch (fn) {
          case 'addEmployee':
            this.sentLog(100117047, {
              role: role === 2 ? '总负责人' : '普通员工'
            })
            break
          case 'editEmployee':
            this.sentLog(100117024, {
              role: role === 2 ? '总负责人' : '普通员工'
            })
            break
          default:
        }
      })
    },
    // 更换岗位为总负责人时，没有资产权限时，提示总负责人未分配的资产
    recommendProducts (id) {
      let formData = {gldUserId: id}
      let list = []
      manageService.checkUnableAssets(formData).then(res => {
        if (res.code === 200) {
          list = res.data || []
          if (list && list.length && list.length > 0) {
            let listStr = list.join('、')
            this.$confirm({
              type: 'warning',
              message: `<span style="color:rgba(33, 37, 48, 0.75); font-size: 14px; line-height: 25px;font-weight: 400;">为保障总负责人正常发挥岗位作业，请前往企业管理页面给总负责人配置如下资产：</span><br /><span style="font-size: 14px; font-weight: 500;color: #212530;line-height: 25px;">${listStr}</span>`,
              submitType: 'minor',
              submitText: '我知道了',
              noCancelBtn: true,
              width: 400,
              submit: () => {
              }
            })
          }
        } else {
        }
      })
    },
    // 删除文件
    handleRemove (file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
    },
    // 批量添加，选择分组
    changeGroup (val) {
      let message = ''
      const groupList = [
        {departmentId: null, departmentName: '全公司'},
        ...this.groupData
      ]
      groupList.forEach(item => {
        if (item.departmentId === val) {
          message = item.departmentName
        }
      })
      this.sentLog(100117010, {message})
    },
    // 批量上传 下载 Excel 模板
    downloadExcelTemplate () {
      const token = getCookie('ZJYTOKEN')
      if (token) {
        manageService.downloadExcelTemplate(token)
      }
    },
    // 点击上传
    includeInput () {
      this.sentLog(100117011)
      this.$refs.excelInput.click()
    },
    // 选择文件
    beforeUpload (file) {
      file = file.currentTarget.files[0]
      this.fileList = [file]
      this.uploadErrorMessage = ''
      if (!/\.xlsx$/.test(file.name)) {
        this.uploadErrorMessage = '文件格式不正确，请上传后缀为xlsx的文件'
      }
      return false
    },
    // 批量添加弹窗确定回调
    handleUpload () {
      if (this.uploading) {
        // 防止重复提交
        return
      }
      const {fileList = []} = this
      if (fileList.length === 0) {
        this.uploadErrorMessage = '您还没有选择上传的Excel'
      } else if (!/\.xlsx$/.test(fileList[0].name)) {
        this.uploadErrorMessage = '文件格式不正确，请上传后缀为xlsx的文件'
      } else {
        captchaIns && captchaIns.verify() // 手动调用verify方法
      }
    },
    // 批量添加弹窗取消回调
    handleUploadCancel () {
      this.fileList = []
      this.uploadErrorMessage = ''
      this.uploadDepartmentId = null
      this.uploadVisible = false
    },
    // 批量添加，接口请求
    addBatchEmployee (verifyOptions = {}) {
      const {fileList} = this
      let formData = new FormData()
      formData.append('file', fileList[0])
      let headers = {
        'Content-Type': 'multipart/form-data'
      }
      Object.assign(verifyOptions, {
        departmentId: this.uploadDepartmentId || ''
      })
      this.uploading = true
      let status = 1
      manageService
        .addBatchEmployee(verifyOptions, formData, headers)
        .then(res => {
          this.uploading = false
          const { code, message, data = {} } = res
          if (code === 200) {
            const successList = data.successList || []
            this.handleUploadCancel()
            this.$message.success(`成功添加${successList.length || 0}名员工，将会短信通知账号及密码`)
            if (Array.isArray(successList) && successList.length) {
              manageService.addRelationLog({
                area: this.userInStore.area,
                detail: successList.map(item => item.account).join(';'),
                operateType: 'CREATE_ACCOUNT',
                relType: '',
                showState: 1
              })
            }
            this.getEmployeeList()
          } else {
            status = 2
            this.uploadErrorMessage = message || '批量添加失败'
          }
          this.sentLog(100117012, {status, message})
        })
        .catch(() => {
          this.uploading = false
          status = 2
          const message = '请求失败'
          this.uploadErrorMessage = message
          this.sentLog(100117012, {status, message})
        })
    },
    // 更新角色
    updateRole ({item, roleId}) {
      this.sentLog(100117051, {role: roleId === 2 ? '总负责人' : '普通员工'})
      let that = this
      let {role, account} = item
      if (role !== 2 && roleId === 2) {
        that.setRole(item, roleId, true)
      } else if ([2].includes(role) && roleId === 4) {
        // that.$confirm({
        //   type: 'warning',
        //   message: `您确定要将<a class="color-blue">${account}</a>更改成【普通员工】角色吗？ 更改后此员工将不再担任【${
        //     role === 2 ? '总负责人' : '档案室负责人'
        //   }】的角色。`,
        //   submitText: '确定',
        //   cancelText: '取消',
        //   submit () {
        //     that.setRole(item, roleId, true)
        //   }
        // })
        that.setRole(item, roleId, true)
      } else if ([2].includes(roleId)) {
        // 设置为普通员工
        that.setRole(item, roleId, true)
      } else {
        // item.role = roleId;
        that.setRole(item, roleId, true)
      }
    },
    // 更新权限
    updataManager ({child}) {
      child.check = true
    },
    dropdownHandle (data, e) {
      data.hover = !data.hover
      this.$forceUpdate()
    },
    treeDropdownHandle (data) {
      console.log(data)
      data.hover = !data.hover
      this.$forceUpdate()
    },
    // 更新角色,接口请求
    setRole (item, role, force = false) {
      console.log(item)

      let that = this
      let {gldUserId, account} = item
      let params = {
        gldUserId,
        role,
        force
      }
      let status = 2
      let message = ''
      this.loading = true
      manageService
        .setRole(params)
        .then(res => {
          this.loading = false
          if (+res.code === 200) {
            manageService.addRelationLog({
              area: this.userInStore.area,
              detail: `${account}被修改岗位为${role === 2 ? '总负责人' : '普通员工'}`,
              operateType: 'EDIT_ACCOUNT',
              relType: '',
              showState: 1
            })
            status = 1
            // 总负责人资产提示：----资产相关紧急输入注释提示
            // if (role === 2) {
            //   this.recommendProducts(gldUserId)
            // }
            if (this.departmentId !== 'null') {
              that.getEmployeeList({departmentId: this.departmentId})
            } else {
              that.getEmployeeList({departmentId: 0})
            }

            this.$message.success('岗位设置成功')

          } else if (res.code === 330002) {
            // // 总负责人已存在
            // let data = res.data || {}
            // let { managerUserName = '' } = data
            // message = '总负责人已存在, 设置新的总负责人 二次确认'
            // that.$confirm({
            //   type: 'warning',
            //   message: `您确定要将<a class="color-blue">${item.account}</a>更改成【总负责人】角色吗？ 更改后，原总负责人<span class="color-blue">${managerUserName}</span>将变成【普通员工】角色。`,
            //   submitText: '确定',
            //   cancelText: '取消',
            //   submit () {
            //     that.setRole(item, role, true)
            //   }
            // })
          } else if (res.code === 330013 && [2].includes(params.role)) {
            // 总负责人不存在
            // message = '设置成总负责人二次确认'
            // that.$confirm({
            //   type: 'warning',
            //   message: `您确定要将<a class="color-blue">${item.account}</a>设置成【总负责人】角色吗？`,
            //   submitText: '确定',
            //   cancelText: '取消',
            //   submit () {
            //     that.setRole(item, role, true)
            //   }
            // })
          } else if (res.code === 340018) {
            message = '角色设置失败'
            that.$message.error(message)
          } else if (res.code === 340019) {
            message = '角色设置失败，用户正在登录'
            that.$message.error(message)
          } else {
            message = res.message || '角色设置失败'
            res.message && that.$message.error(res.message)
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 操作列事件
    handlerAction ({item, type}) {
      this.currentRow = item
      switch (type) {
        case 'editor':
          this.onEditor(item)
          break
        case 'password':
          this.onResetPassword(item)
          break
        case 'config':
          // this.sentLog(100117027)
          if (item) {
            this.configItem = item
          }
          this.showConfigAssetAfterAddUser = false
          this.showConfigAsset++
          break
        case 'setting':
          this.sentLog(100117031)
          this.configItem = item
          this.showConfigLent++
          break
        case 'delete':
          this.sentLog(100117033)
          this.onDelete(item)
          break
        default:
        // console.log('default');
      }
    },
    // 配置资产、设置借出 确定 -- 记得刷新下列表
    onConfigSubmit (type) {
      // 刷新下列表
      this.getEmployeeList()
      this.onConfigCancel(type)
    },
    // 关闭 配置资产、设置借出 弹窗
    onConfigCancel (type) {
      this.$nextTick(() => {
        this['showConfig' + type] = 0
        this.configItem = {}
      })
    },
    // 编辑
    onEditor (item) {
      this.sentLog(100117019)
      let itemRow = clone(item)
      itemRow.account = item.account.substring(
        0,
        item.account.lastIndexOf('@')
      )
      this.memberInfo = Object.assign(
        {password: '**********', originRole: itemRow.role},
        itemRow
      )
      this.isEditor = true
      this.showAddMember = true
    },
    // 重置密码
    onResetPassword () {
      this.sentLog(100117025)
      this.visible = true
    },
    // 重置密码，请求接口
    handleOk () {
      let {currentRow = {}, passwordForm = {}} = this
      let status = 2
      let message = ''
      this.$refs.passwordForm.validate(valid => {
        if (valid && !isEmptyObject(currentRow)) {
          let params = {
            account: currentRow.account,
            newPassword: encodeURIComponent(passwordForm.password)
          }
          this.confirmLoading = true
          manageService
            .resetPassword(params)
            .then(res => {
              if (+res.code === 200 && res.data === true) {
                manageService.addRelationLog({
                  area: this.userInStore.area,
                  detail: `${currentRow.account}被重置密码`,
                  operateType: 'EDIT_ACCOUNT',
                  relType: '',
                  showState: 1
                })
                status = 1
                this.$message.success('密码重置成功')
                this.confirmLoading = false
                this.handleCancel()
              } else {
                message = res.message || '密码重置失败'
                this.$message.error(message)
              }
              this.sentLog(100117026, {status, message})
            })
            .catch(() => {
              this.confirmLoading = false
              message = '请求失败'
              this.sentLog(100117026, {status, message})
            })
        }
      })
    },
    // 取消重置密码
    handleCancel () {
      this.currentRow = {}
      this.passwordForm.password = ''
      this.$refs.passwordForm.resetFields()
      this.visible = false
    },
    // 删除事件
    onDelete ({account, gldUserId}) {
      let that = this
      let status = 2
      let message = ''
      this.$confirm({
        type: 'warning',
        message: '确定删除员工吗？',
        tips: '员工将从公司组织中删除，并收回产品权限',
        multipleSubmit: [
          {type: 'primary', name: '确定', key: 'open', value: 1}, // 删除确认弹窗 确定 按钮灰显
          {type: 'minor', name: '取消', key: 'open', value: 0} // 删除确认弹窗 取消 按钮亮显
        ],
        submit: data => {
          // console.log(data)
          if (data && +data.open === 1) {
            manageService.deleteEmployee({gldUserId}).then(res => {
              if (res.code === 200) {
                manageService.addRelationLog({
                  area: this.userInStore.area,
                  detail: account,
                  operateType: 'DELETE_ACCOUNT',
                  relType: '',
                  showState: 1
                })
                status = 1
                message = res.message || '账号成功删除'
                that.$message.success(message)
                that.getEmployeeList({departmentId: this.departmentId})
              } else {
                switch (+res.code) {
                  // case 330027:
                  //   that.$message.error(res.message)
                  //   break
                  case 340014:
                    message = '删除员工失败，用户正在登录'
                    that.$message.error(message)
                    break
                  case 340037:
                    message =
                      '当前员工账号正在联网或借出使用产品，请退出使用或归还后，再尝试删除'
                    this.$confirm({
                      message: '删除失败',
                      type: 'warning',
                      tips: message,
                      submitText: '我知道了',
                      noCancelBtn: true
                    })
                    break
                  default:
                    message = res.message || '删除员工失败'
                    that.$message.error(message)
                }
              }
              that.sentLog(100117034, {status, message})
            })
          }
        },
        noCancelBtn: true,
        width: 400
      })
    },
    closeTips () {
      this.showMemTips = false
      api.common.setTips('MEMTIPS').then(res => {
        if (res.code === 200) {
          console.log('MEMTIPS_close')
        }
      })
    },
    closeRoleTip () {
      this.setGuide(0)
    },
    initTips () {
      api.common.getTips().then(res => {
        if (res.code === 200) {
          let data = res.data || {}
          console.log(!data.MEMTIPS)
          this.showMemTips = !data.MEMTIPS
          // 十秒后自动关闭提示
          setTimeout(() => {
            this.showMemTips = false
            api.common.setTips('MEMTIPS').then(res => {
              if (res.code === 200) {
                console.log('MEMTIPS_close')
              }
            })
          }, 10000)
        }
      })
    },
    // 全选
    handleCheckAllChange (val) {
      this.isIndeterminate = false
      this.data.forEach((item) => {
        item.checkbox = val
      })
      if (val) {
        for (let index = 0; index < this.data.length; index++) {
          let getLocation = this.selectedAccountArr.indexOf(this.data[index])
          if (getLocation === -1){
            this.selectedAccountArr.push(this.data[index])
          }
        }
      } else {
        this.selectedAccountArr = []
      }
    },
    // 单选改变全选状态
    handleCheckedCitiesChange (item) {
      let checkedCount = this.data.filter(item => item.checkbox).length
      let checkedNot = this.data.length
      this.checkAll = checkedCount === checkedNot
      this.isIndeterminate = checkedCount > 0 && checkedCount < checkedNot
      if (item.checkbox) {
        this.selectedAccountArr.push(item)
      } else {
        let getLocation = this.selectedAccountArr.indexOf(item)
        this.selectedAccountArr.splice(getLocation, 1)
      }
    },
    // 批量移动
    moveMembers () {
      this.showMoveMember = true
      if (this.departmentId === null){
        this.departmentMoveName = '全公司'
        this.$refs.moveTree.setCurrentKey(null)
      } else {
        this.departmentMoveName = this.departmentName
        this.$refs.moveTree.setCurrentKey(this.departmentId)
      }
      this.sentLog(100117112)
    },
    // 批量移动接口请求
    moveRelationBatch (verifyOptions = {}){
      let that = this
      let message = ''
      let gldUserIdList = this.selectedAccountArr.map(({departmentId, name, passwordMobile, remark = '', role, gldUserId}) => ({departmentId, name, passwordMobile, remark, role, gldUserId}))
      gldUserIdList.forEach(item => {
        item.departmentId = this.$refs.moveTree.getCurrentKey()
      })
      let accountList = this.selectedAccountArr.map(item => { return item.account })
      let detailList = accountList.join(';')
      manageService.moveRelationBatch(verifyOptions, gldUserIdList).then(res => {
        if (res.code === 200 && res.data !== 0) {
          manageService.addRelationLog({
            area: this.userInStore.area,
            detail: `${this.departmentMoveName}--${detailList}`,
            operateType: 'BATCH_MOVE_ACCOUNT',
            relType: '',
            showState: 1
          })
          message = res.message || `成功移动${res.data}个账号至${that.departmentMoveName}`
          that.$message.success(message)
          that.getEmployeeList({departmentId: this.departmentId})
          that.sentLog(100117113, {number: res.data})
        } else {
          message = res.message || '账号移动失败'
          that.$message.error(message)
        }
      })
        .catch(() => {
          that.$message.error('账号移动失败')
        })
      this.showMoveMember = false
    },
    // 批量移动弹窗确定回调
    handlerMoveMember () {
      captchaIns && captchaIns.verify() // 手动调用verify方法
    },
    // 批量移动弹窗取消回调
    handlerMoveClose () {
      this.showMoveMember = false
    },
    // 批量删除事件
    onBatchDelete () {
      let that = this
      let message = ''
      that.sentLog(100117110)
      this.$confirm({
        type: 'warning',
        message: '确定删除员工吗？',
        tips: '员工将从公司组织中删除，并收回产品权限',
        multipleSubmit: [
          {type: 'primary', name: '确定', key: 'open', value: 1}, // 删除确认弹窗 确定 按钮灰显
          {type: 'minor', name: '取消', key: 'open', value: 0} // 删除确认弹窗 取消 按钮亮显
        ],
        submit: data => {
          // console.log(data)
          if (data && +data.open === 1) {
            let gldUserIdList = this.selectedAccountArr.map(item => { return item.gldUserId })
            let accountList = this.selectedAccountArr.map(item => { return item.account })
            let detailList = accountList.join(';')
            manageService.deleteEmployees(gldUserIdList).then(res => {
              if (res.code === 200 && res.data !== 0) {
                manageService.addRelationLog({
                  area: this.userInStore.area,
                  detail: detailList,
                  operateType: 'BATCH_DELETE_ACCOUNT',
                  relType: '',
                  showState: 1
                })
                message = res.message || `成功删除${res.data}个账号`
                that.$message.success(message)
                that.getEmployeeList({departmentId: this.departmentId})
                that.sentLog(100117111, {number: res.data})
              } else {
                message = res.message || '账号删除失败'
                that.$message.error(message)
              }
            }).catch(() => {
              that.$message.error('账号删除失败')
            })
          }
        },
        noCancelBtn: true,
        width: 400
      })
    },
    // 批量移动点击事件
    clickMoveGroupNode ({departmentId, departmentName}) {
      this.$refs.moveTree.setCurrentKey(departmentId)
      this.departmentMoveName = departmentName
    },
    // 获取所属分组名称
    getDepartmentName (val){
      if (val === null){
        return '全公司'
      } else {
        let departmentNameVal = ''
        const formatData = (arr) => {
          arr.forEach((ele) => {
            if (ele.departmentId === val) {
              departmentNameVal = ele.departmentName
            }
            if (ele.subList.length > 0) {
              formatData(ele.subList)
            }
          })
        }
        formatData(this.groupData)
        return departmentNameVal
      }
    },
    initFrozenTip () {
      api.common.getTips().then(res => {
        if (res.code === 200) {
          let data = res.data || {}
          this.showFrozenTip = !data.FROZEN
          // 十秒后自动关闭提示
          setTimeout(() => {
            this.showFrozenTip = false
            api.common.setTips('FROZEN').then(res => {
              if (res.code === 200) {
                console.log('FROZEN_close')
              }
            })
          }, 10000)
        }
      })
    },
    closeFrozenTip () {
      this.showFrozenTip = false
      api.common.setTips('FROZEN').then(res => {
        if (res.code === 200) {
          console.log('FROZEN_close')
        }
      })
    }
  },
  watch: {
    foldMenu (newVal, oldVal) {
      if (newVal !== oldVal) {
        setTimeout(() => {
          this.calcTableHeight()
        }, 500)
      }
    }
  }
}
</script>
<style scoped>

  .icon-block {
    color: #1890ff;
    visibility: visible !important;
  }
</style>
<style lang="less">
  .manage-members {
    .search_type_select{
      margin-left: 10px;
      .w__input__inner {
        &:focus {
          outline: none;
          box-shadow: none;
          border-color: #DCDFE6;
        }
      }
      .w__input [class^=r2-icon-] {
        font-size: 20px !important;
      }
      .r2-icon-action_search{
        font-size: 20px !important;
      }
    }
    .search_type_input {
      margin-left: -2px;

      .w__input__inner {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    }
  }

  .w__checkbox__input.is-disabled.is-checked .w__checkbox__inner {
    background-color: rgba(32, 121, 250, 0.35) !important;
  }

  body .w__checkbox__input.is-checked + .w__checkbox__label {
    color: rgba(33, 37, 48, 0.8);
  }

  .asset-item {
    line-height: 20px;
    cursor: default;

    &--title {
      margin-bottom: 4px;
    }

    &--default {
      cursor: pointer !important;
      color: #2079fa !important;
    }
  }

  .manage-members {
    overflow: hidden;
    height: 100%;

    .text-no {
      color: rgba(0, 0, 0, 0);
      user-select: none;
    }

    .hoverBlock {
      visibility: visible !important;
      color: #1890ff;
    }

    .hover-show {
      visibility: hidden;
    }

    .hover-row {
      &:hover {
        .hover-show {
          visibility: visible;
        }
      }
    }

    .header-explain-relative {
      position: relative;
      left: 0;
      top: 1px;
    }

    .opration-text {
      color: rgba(32, 121, 250, 1);
      margin-right: 12px;

      &:hover {
        color: #2079fa;
      }
    }

    .header-explain {
      position: relative;
      top: -2px;
      left: 5px;

      &::before {
        font-size: 17px;
      }
    }

    .group {
      width: 240px;
      height: 100%;
      background: rgba(255, 255, 255, 1);
      border-right: 1px solid #e0e2e5;
      padding: 24px 0;
      box-sizing: border-box;

      .add-group {
        height: 32px;
        padding: 0 16px 10px;
      }

      .group-container {
        margin-top: 6px;
        height: calc(100% - 32px);
        /*overflow: hidden;*/
        -webkit-user-select: none;
        font-size: 14px;
        color: rgba(33, 37, 48, 1);

        .group--all {
          // padding: 0 16px;
        }

        .group-name {
          height: 40px;
          line-height: 40px;
          font-weight: bold;
          cursor: pointer;

          &:hover {
            background: #F3F4F7;
          }

          i {
            transform: rotate(-90deg);
            transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);

            &.expand {
              transform: rotate(0deg);
            }
          }
        }

        .group-lists {
          & > ul {
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            color: rgba(0, 0, 0, 0.65);
            font-variant: tabular-nums;
            line-height: 1.5;
            list-style: none;
            -webkit-font-feature-settings: "tnum";
            font-feature-settings: "tnum";
            margin: 0;
            /*padding: 0 0 100px 0;*/

            li {
              &.group-item {
                &:hover {
                  background: #fafafa;
                }
              }

              margin: 0;
              padding: 4px 10px 4px 18px;
              /*white-space: nowrap;*/
              list-style: none;
              outline: 0;
              cursor: pointer;

              .editor {
                position: relative;
              }

              .textarea {
                /*background-color: #fff;*/
                /*border-radius: 4px;*/
                /*border: 1px solid #dcdfe6;*/
                /*box-sizing: border-box;*/
                /*color: #606266;*/
                /*outline: none;*/
                /*padding: 5px 20px 5px 5px;*/
                /*transition: border-color .2s cubic-bezier(.645, .045, .355, 1);*/
                /*width: 100%;*/

                .w__textarea__inner {
                  padding: 5px 25px 5px 5px !important;
                }
              }

              .suffix {
                position: absolute;
                top: 50%;
                z-index: 2;
                display: flex;
                align-items: center;
                color: rgba(0, 0, 0, 0.65);
                line-height: 0;
                transform: translateY(-50%);
                right: 2px;
                font-weight: 400;
                white-space: nowrap;
                text-align: center;
                background-image: none;
                box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
                cursor: pointer;
                /*transition: all .3s cubic-bezier(.645, .045, .355, 1);*/
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;
                user-select: none;
                /*touch-action: manipulation;*/
                padding: 0 3px;
                font-size: 12px;
                border-radius: 4px;
                color: rgba(0, 0, 0, 0.65);
                background-color: #fff;
                border: 1px solid #fff;

                i {
                  color: rgba(0, 0, 0, 0.45);
                }

                &:hover {
                  background: #fafafa;

                  i {
                    color: #1890ff;
                  }
                }
              }

              .button {
                position: relative;
                display: inline-block;
                font-weight: 400;
                white-space: nowrap;
                text-align: center;
                background-image: none;
                box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
                cursor: pointer;
                transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;
                user-select: none;
                /*touch-action: manipulation;*/
                padding: 0 3px;
                font-size: 12px;
                border-radius: 4px;
                color: rgba(0, 0, 0, 0.65);
                background-color: #fff;
                border: 1px solid #fff;

                i {
                  color: rgba(0, 0, 0, 0.45);
                }

                &:hover {
                  background: #fafafa;

                  i {
                    color: #1890ff;
                  }
                }
              }

              &:hover {
                .item-container {
                  .icon {
                    visibility: visible;

                    &:hover {
                      .context--menu {
                        display: block;
                      }
                    }
                  }
                }
              }

              .item-container {
                .title {
                  word-break: break-all;
                  width: 100%;
                  line-height: 22px;
                }

                .icon {
                  width: 20px;
                  color: #1890ff;
                  visibility: hidden;

                  .context--menu {
                    width: 120px;
                    padding: 8px 0;
                    position: absolute;
                    right: -5px;
                    top: 22px;
                    z-index: 9999;
                    background-color: #fff;
                    border-radius: 4px;
                    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
                    display: none;

                    ul {
                      color: rgba(0, 0, 0, 0.65);

                      li {
                        width: 100%;
                        display: flex;
                        height: 32px;
                        line-height: 32px;
                        padding: 0 16px;
                        cursor: pointer;
                        box-sizing: border-box;

                        &:hover {
                          background: #fafafa;
                        }

                        span {
                          font-size: 14px;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }

        .group--deleted {
          padding: 0 24px;
          height: 40px;
          line-height: 40px;
          font-weight: bold;
          cursor: pointer;

          &.active {
            background-color: #f3f4f7;
            color: #2079fa;
          }
        }
      }
    }

    .box {
      width: 100%;
      height: 100%;

      .table-container {
        width: 100%;
        height: 100%;
        padding: 24px 25px;
        box-sizing: border-box;

        .btn-wrapper {
          .group-name {
            width: 200px;
            height: 24px;
            font-size: 16px;
            font-weight: bold;
            color: rgba(33, 37, 48, 1);
            line-height: 24px;
          }
        }

        .table-wrapper {
          margin-top: 16px;

          .role-setting {
            i {
              font-size: 12px;
            }
          }

          .w__dropdown-link {
            .more {
              cursor: pointer;

              &:hover {
                color: #1a6dcd;
              }
            }
          }
        }
      }
    }

    .ant-pagination-options-quick-jumper input {
      box-sizing: border-box !important;
    }
  }

  .add-members-batch {
    .flex {
      .label {
        width: 38px;
        height: 32px;
        line-height: 32px;
        padding-right: 10px;
      }

      .select__inner {
        background-color: #fff;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        font-size: inherit;
        height: 32px;
        line-height: 32px;
        outline: none;
        padding: 0 15px;
        transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
        width: 200px;
      }

      .upload-help-block {
        font-size: 12px;
        display: inline-block;
        line-height: 32px;
        padding-left: 10px;

        a:link,
        a:visited {
          color: rgb(32, 121, 250);
        }
      }
    }
  }

  .members-tips {
    position: absolute;
    right: 321px;
    top: 128px;
    z-index: 999;
    animation: dialog-fade-in 0.3s;

    .rectangle {
      position: absolute;
      z-index: 10;
      text-align: left;
      bottom: 0;
      left: 0;
      width: 300px;
      height: 74px;
      line-height: 74px;
      background: rgba(32, 121, 250, 1);
      box-shadow: 0px 2px 8px 0px rgba(33, 37, 48, 0.15);
      border-radius: 4px;

      div {
        margin-left: 16px;
        font-size: 16px;
        font-weight: 400;
        line-height: 74px;
        display: block;
        color: rgba(255, 255, 255, 1);
      }

      & > i {
        margin-left: 20px;
        font-size: 32px;
        line-height: 74px;
        color: rgba(255, 255, 255, 1);
      }

      .prj-tips-i {
        position: absolute;
        font-size: 20px;
        width: 20px;
        height: 20px;
        line-height: 20px;
        right: 8px;
        top: 8px;
        color: rgba(255, 255, 255, 0.55);
        cursor: pointer;
      }
    }

    .triangle {
      position: absolute;
      bottom: 74px;
      left: 260px;
      content: "";
      width: 0;
      height: 0;
      border-top: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 10px solid rgba(32, 121, 250, 1);
      border-left: 10px solid transparent;
    }
  }

  .role-tips {
    position: absolute;
    left: 172px;
    top: 150px;
    z-index: 999;
    animation: dialog-fade-in 0.3s;

    .rectangle {
      position: absolute;
      z-index: 10;
      text-align: left;
      bottom: 0;
      left: 0;
      width: 324px;
      height: 95px;
      line-height: 24px;
      background: rgba(32, 121, 250, 1);
      box-shadow: 0px 2px 8px 0px rgba(33, 37, 48, 0.15);
      border-radius: 4px;

      .content-tips {
        float: right;
        width: 238px;
        color: #fff;
        margin-top: 20px;
        margin-right: 17px;
        font-size: 16px;
      }

      & > i {
        margin-left: 20px;
        margin-top: 26px;
        font-size: 32px;
        color: rgba(255, 255, 255, 1);
      }

      .prj-tips-i {
        position: absolute;
        font-size: 20px;
        width: 20px;
        height: 20px;
        line-height: 20px;
        right: 10px;
        top: -19px;
        color: rgba(255, 255, 255, 0.55);
        cursor: pointer;
      }
    }

    .triangle {
      position: absolute;
      bottom: 95px;
      left: 28px;
      content: "";
      width: 0;
      height: 0;
      border-top: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 10px solid rgba(32, 121, 250, 1);
      border-left: 10px solid transparent;
    }
  }

  .suffix-reg-tip {
    p {
      span {
        color: #dc143c;
        font-weight: 800;
      }

      &.account-guide__wrapper {
        margin-top: 12px;

        a:link,
        a:visited {
          color: rgb(32, 121, 250);
        }
      }
    }
  }

  .w-tree {
    .custom-tree-node {
      width: 75%;

      .item-container {
        width: 100%;
        justify-content: space-between;
      }
    }

    .organizationTitle {
      word-break: break-word;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      height: 32px;
      line-height: 32px;
      display: block;
    }

    .w-tree-node__content {
      height: 100% !important;

      .icon {
        visibility: hidden;
      }

      &:hover {
        .item-container {
          .icon {
            visibility: visible;
          }
        }
      }

    }

    .w__dropdown-menu__item {
      padding: 0 16px;
    }
  }

  .w-tree-node__expand-icon {
    padding: 8px !important;
    margin-left: 12px;
  }

  .move-members-batch{
    user-select: none;
    .w__dialog--title{
      font-size: 16px;
      color: #212530;
      line-height: 24px;
      font-weight: bold;
    }
    .group-name {
          height: 40px;
          line-height: 40px;
          cursor: pointer;
          &:hover {
            background: #F3F4F7;
          }

          i {
            transform: rotate(-90deg);
            transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
            color: #2125308c;

            &.expand {
              transform: rotate(0deg);
              color: #2125308c;
            }
          }
        }
   }

  .frozen-tips {
    position: fixed;
    // left: 1px;
    // top: 0px;
    margin-left: 100px;
    z-index: 2001;
    animation: dialog-fade-in 0.3s;
    margin-top: 49px;
    cursor: auto;
    .rectangle {
      position: absolute;
      z-index: 10;
      text-align: left;
      bottom: 0;
      left: 0;
      width: 334px;
      height: 110px;
      // line-height: 110px;
      background: rgba(32, 121, 250, 1);
      box-shadow: 0px 2px 8px 0px rgba(33, 37, 48, 0.15);
      border-radius: 4px;
      display: flex;
      .rectangle-span {
        font-size: 16px;
        font-weight: 400;
        display: flex;
        line-height: 24px;
        margin: 21px 29px 17px 19px;
        color: rgba(255, 255, 255, 1);
      }

      .rectangle-i {
        display: flex;
        margin-left: 20px;
        font-size: 32px;
        line-height: 80px;
        color: rgba(255, 255, 255, 1);
      }

      .prj-tips-i {
        position: absolute;
        font-size: 20px;
        width: 20px;
        height: 20px;
        line-height: 20px;
        right: 8px;
        top: 8px;
        color: rgba(255, 255, 255, 0.55);
        cursor: pointer;
      }
    }

    .triangle {
      position: absolute;
      top: -83px;
      left: -19px;
      content: "";
      width: 0;
      height: 0;
      border-top: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 10px solid rgba(32, 121, 250, 1);
      border-left: 10px solid transparent;
      transform: rotate(-90deg);
    }
  }
</style>
<style lang="less">
  .w-tree {
    .w-tree-node__content {
      height: max-content !important;
      align-items: baseline !important;
      /* padding: 5px 0px  !important; */

      &:hover {
        background-color: #f3f4f7 !important;
        // color: #2079FA  !important;
      }
    }

    .w-tree-node__expand-icon {
      padding: 4px !important;
      margin-left: 24px;
      font-size: 20px;
    }

    .w__input__inner {
      height: 32px !important;
    }

    .w__dropdown {
      height: 100% !important;
      display: flex !important;
      align-items: center !important;
    }

    .w-tree-node__expand-icon {
      transform: rotate(-90deg) translateX(-2px);
      color: #2125308c;
    }

    .w-tree-node__expand-icon.expanded {
      transform: rotate(0deg) translateY(2px);
      color: #2125308c;
    }

    .is-leaf {
      color: transparent;
    }
  }

  .w__dropdown-menu__item:not(.is-disabled):hover {
    background-color: #f3f4f7 !important;
  }

  .w-tree--highlight-current .w-tree-node.is-current > .w-tree-node__content {
    background-color: #f3f4f7 !important;
    color: #2079FA;
    font-weight: bold;

    .w-tree-node__expand-icon {
      color: #2079FA;
    }

    .is-leaf {
      color: transparent;
    }
  }

  .w-cascader-node {
    .w__radio {
      margin-right: 0 !important;
    }
  }
</style>
